import {
  Button,
  Tooltip
} from "@material-ui/core";
import { Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import { CSSProperties } from "@material-ui/core/styles/withStyles";
import * as React from "react";
import {
  ISurveyEvaluationResponses,
} from "src/services";
import Component from "../../../components/Component";
import Modal, { IModalProps } from "../../../components/Modal";
import withAxios, { IAxiosProps } from "../../../components/withAxios";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import TextField from "@material-ui/core/TextField";
import EmailValidator from "email-validator";
import CircularProgress from "@material-ui/core/CircularProgress";
import * as format from "date-fns/format";
import "../../director/template-editor/report-style.css"
// import { ICoach } from "src/services";
// import { ISport } from "src/services";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import gritLogo from "src/assets/gritlogo.png";
import winTheDayImg from "src/assets/wtd.png";
import champions101Img from "src/assets/c101.png";

const styles = (theme: Theme): Record<string, CSSProperties> => ({
  modal: {
    height: "80%",
    width: "80%",
  },
  summaryBox: {
    backgroundColor: "#efefef",
    border: "1px solid #424242",
    borderRadius: 4,
    padding: `${theme.spacing(1)}px ${theme.spacing(1)}px ${theme.spacing(
      1
    )}px ${theme.spacing(1)}px`,
  },
  text: {
    overflowWrap: "break-word",
    whiteSpace: "pre-wrap",
  },
  openSurveyTooltip: {
    backgroundColor: "#212121",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.28)",
    fontFamily: "Arial, sans-serif",
    fontSize: "16px",
    fontWeight: 500,
    letterSpacing: 0,
    lineHeight: "22px",
    maxWidth: "520px",
    padding: "12px 16px",
  },
});

/** Default team connectedness score items (label + score) when report has none */
const DEFAULT_TEAM_CONNECTEDNESS_SCORES = [
  { label: "Fear of mistakes" },
  { label: "Values my skills" },
  { label: "Encourages corrections" },
  { label: "Easy to ask for help" },
  { label: "Respects Input" },
  { label: "Encouraging Environment" },
  { label: "Welcomes Tough Issues"},
  { label: "Love Being on Team" },
];


/** Percent change helper based on current vs previous value */
function getPercentChange(current?: number | null, previous?: number | null): number | null {
  if (
    current == null ||
    previous == null ||
    isNaN(Number(current)) ||
    isNaN(Number(previous))
    //  ||
    // Number(previous) === 0
  ) {
    return null;
  }
  if (Number(current) === Number(previous)){
    return "NoChange" as any;
  }else if (Number(previous) === 0){
    return 100;
  }else{
  return ((Number(current) - Number(previous)) / Number(previous)) * 100;
  }
 
}

function getPercentClass(change: number | null): string {
  if (change === null || change === 0 ) {return "small-blue-text";}
  if (change > 0) {return "small-green-text";}
  if (change < 0){ return "small-red-text";}
  return "small-blue-text";
}

function formatPercent(change: number | null): string {
  if (change === null) {return "0%";}
  if (change === "NoChange" as any) {return "no change";}
  const rounded = Math.round(change);
  const sign = rounded > 0 ? "+" : "";
  return `${sign}${rounded}%`;
}

/** Textarea that sets its height to match content (no scrollbar for content) */
// const AutoHeightTextarea: React.FC<React.TextareaHTMLAttributes<HTMLTextAreaElement>> = (props) => {
//   const ref = React.useRef<HTMLTextAreaElement>(null);
//   const adjustHeight = React.useCallback(() => {
//     const el = ref.current;
//     if (!el) {
//       return;
//     }
//     el.style.height = "auto";
//     el.style.height = el.scrollHeight + "px";
//   }, []);
//   React.useEffect(() => {
//     adjustHeight();
//   }, [adjustHeight, props.defaultValue]);
//   return (
//     <textarea
//       {...props}
//       ref={ref}
//       onInput={(e) => {
//         adjustHeight();
//         props.onInput?.(e);
//       }}
//       style={{ ...props.style, overflow: "hidden" }}
//     />
//   );
// };

interface IExtraProps {
  slug: string;
  // coach: ICoach;
  // sport: ISport;
  schoolId: number;
  isParentModal?: "true" | "false";
  schoolData: any
  ReportData: any
  refreshReports: () => Promise<void>;
  readOnly?: boolean;
  hideGenerateReportButton?: boolean;
  hasOpenSurveysInSeason?: boolean;
  seasonReportDateRange?: string;
}

type IBaseProps = IModalProps & IExtraProps;

type IProps = IBaseProps &
  IAxiosProps &
  WithStyles<keyof ReturnType<typeof styles>>;


interface ISurveyResponsesModalState {
  loading?: true;
  index: number;
  surveyResponse?: ISurveyEvaluationResponses;
  showDeleteConfirmation?: true;
  isDeleting?: true;
  editableReportData?: any[];
  confirmGenerateReportOpen: boolean; // NEW

  emailModalOpen?: boolean;
  emailReportId?: number;
  emailValue?: string;
  emailSending?: boolean;
  emailError?: string;
  emailSuccess?: string;
  showLoader?: boolean;

  // Form data state
  formData?: {
    [key: string]: {
      highlights?: string[];
      overall_summary?: string;
      parentFeedback_appreciate?: string;
      parentFeedback_suggestions?: string;
      parentFeedback?: string[];
      coachSuggestions_0?: string;
      coachSuggestions_1?: string;
      team_connectedness_intro?: string;
      // Grit Leadership Action Plan editable fields
      grit_mid_season_actions?: string;
      grit_post_season_actions?: string;
      grit_season_end_reviews?: string;
      continuingDev?: string[];
      coachSuggestionsAD?: string;
      resources?: string[];
      chatgptChanges?: Record<string, string>;
    }
  }
}

// function cleanAndFormatHtml(input: string): string {
//       if (typeof input !== "string") {
//           return "";
//         }
//         const html = input
//           .replace(/\*\*(.*?)\*\*/g, "<b>$1</b>")
//           .replace(/\*(.*?)\*/g, "<b>$1</b>");

//         const div = document.createElement("div");
//         div.innerHTML = html;

//         div.querySelectorAll("style").forEach(tag => tag.remove());
//         div.querySelectorAll("[style]").forEach(el => el.removeAttribute("style"));

//         return div.innerHTML;
//       }



function cleanAndFormatHtml_New(input: string): string {
  const html = input
    .replace(/\*\*(.*?)\*\*/g, "<b>$1</b>")
    .replace(/\*(.*?)\*/g, "<b>$1</b>");

  const div = document.createElement("div");

  // If no HTML tags exist, wrap text in a span so styles can be applied
  if (!/<[a-z][\s\S]*>/i.test(html)) {
    div.innerHTML = `<span>${html}</span>`;
  } else {
    div.innerHTML = html;
  }

  div.querySelectorAll<HTMLElement>("*").forEach(el => {
    // el.style.color = "red";
    el.style.setProperty("font-family", '"Open Sans", sans-serif');

  });
  console.log("innerHtml:::::::", div.innerHTML);

  return div.innerHTML; // Now contains inline styles
}


export default withStyles(styles, { withTheme: true })(


  withAxios(
    class GenerateReportModal extends Component<
      IProps,
      ISurveyResponsesModalState
    > {
      public readonly state = this.buildState({
        index: 0,
        editableReportData: [],
        confirmGenerateReportOpen: false,// add this

        showLoader: false, // <-- add this
      });

      public componentDidMount() {
        // Process data immediately when component mounts
        if (this.props.ReportData && Array.isArray(this.props.ReportData) && this.props.ReportData.length > 0) {
          const editableReportData = this.props.ReportData.map((report: any) => {
            let parsedResponse = {};
            try {
              parsedResponse = report.chatgptChangeResposne
                ? typeof report.chatgptChangeResposne === 'string'
                  ? JSON.parse(report.chatgptChangeResposne.replace(/[\r\n]+/g, ''))
                  : report.chatgptChangeResposne
                : {};
            } catch (e) {
              console.warn("Invalid JSON in chatgptChangeResposne:", report.chatgptChangeResposne);
            }
            return {
              ...report,
              chatgptChangeResposne: parsedResponse,
            };
          });
          
          this.setState({ editableReportData }, () => {
            // Initialize formData after setting editableReportData
            this.initializeFormData();
          });
        }
      }

      public componentDidUpdate(prevProps: IProps) {
        console.log("componentDidUpdate - ReportData changed:", this.props.ReportData !== prevProps.ReportData);
        console.log("ReportData:", this.props.ReportData);
        if (this.props.ReportData !== prevProps.ReportData && this.props.ReportData) {
          console.log("Processing ReportData, length:", this.props.ReportData.length);
          const editableReportData = this.props.ReportData.map((report: any) => {
            let parsedResponse = {};


            try {
              parsedResponse = report.chatgptChangeResposne
                ? typeof report.chatgptChangeResposne === 'string'
                  ? JSON.parse(report.chatgptChangeResposne.replace(/[\r\n]+/g, ''))
                  : report.chatgptChangeResposne // already parsed
                : {};
            } catch (e) {
              console.warn("Invalid JSON in chatgptChangeResposne:", report.chatgptChangeResposne);
            }

            return {
              ...report,
              chatgptChangeResposne: parsedResponse,
            };
          });

          console.log("Setting editableReportData:", editableReportData);
          this.setState({ editableReportData }, () => {
            // Initialize formData after setting editableReportData
            this.initializeFormData();
          });
        }
      }

      

      public render() {
        const { open, classes, ReportData } = this.props;
        console.log("ReportData in GenerateReportModal:", ReportData, this.props);
        return (
          <Modal
            open={open}
            closeModal={this.props.closeModal}
            className={classes.modal}
          >
            {this.state?.showLoader && (
              <div
                style={{
                  position: "absolute", // absolute to modal
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: "rgba(0,0,0,0.3)",
                  zIndex: 9999,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column"
                }}
              >
                <CircularProgress size={60} style={{ color: "#1976d2" }} />
                <div style={{ color: "#fff", fontSize: 22, marginTop: 24, textAlign: "center" }}>
                  Your report is being generated. It may take 3–5 minutes—thanks for your patience.
                  {/* Summary generation in progress, Do not refresh your screen. Please wait... */}
                </div>
              </div>
            )}
            {this.renderEditableReportData()}

          </Modal>
        );
      }

      // ---------------------- Private helpers ----------------------
      // private handleOpenEmailModal = (reportId: number) => {
      //   this.setState({ emailModalOpen: true, emailReportId: reportId, emailValue: "", emailError: "", emailSuccess: "" });
      // };
      //  private handleAutoNumbering = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
      //   const textarea = e.currentTarget;
      //   const value = textarea.value;
      //   const cursorPosition = textarea.selectionStart;

      //   // Check if Enter key is pressed
      //   if (e.key === 'Enter') {
      //     e.preventDefault();
          
      //     // Get text before cursor
      //     const textBeforeCursor = value.substring(0, cursorPosition);
      //     const textAfterCursor = value.substring(cursorPosition);
          
      //     // Find all numbered items (e.g., "1. ", "2. ", etc.)
      //     const numberedPattern = /^(\d+)\.\s/gm;
      //     const matches = textBeforeCursor.match(numberedPattern);
          
      //     let nextNumber = 1;
      //     if (matches && matches.length > 0) {
      //       // Find the highest number
      //       const numbers = matches.map(match => parseInt(match.match(/\d+/)?.[0] || '0', 10));
      //       nextNumber = Math.max(...numbers) + 1;
      //     }
          
      //     // Insert new line with next number
      //     const newText = textBeforeCursor + `\n${nextNumber}. ` + textAfterCursor;
      //     textarea.value = newText;
          
      //     // Set cursor position after the inserted number
      //     const newCursorPosition = cursorPosition + `\n${nextNumber}. `.length;
      //     textarea.setSelectionRange(newCursorPosition, newCursorPosition);
          
      //     // Trigger input event to adjust height
      //     const inputEvent = new Event('input', { bubbles: true });
      //     textarea.dispatchEvent(inputEvent);
      //   }
      // };
      private handleCloseEmailModal = () => {
        this.setState({ emailModalOpen: false, emailReportId: undefined, emailValue: "", emailError: "", emailSuccess: "" });
      };

      private handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ emailValue: e.target.value, emailError: "", emailSuccess: "" });
      };

      private handleSendEmail = async () => {
        const { emailReportId, emailValue } = this.state as any;
        const isEmailValid = EmailValidator.validate(emailValue);
        if (!emailValue || !isEmailValid) {
          this.setState({ emailError: "Please enter a valid email address." });
          return;
        }
        this.setState({ emailSending: true, emailError: "", emailSuccess: "" });
        try {
          await this.buildPost<any, any>(
            this,
            "/reports/reportSend"
          )({ id: emailReportId, email: emailValue });
          this.setState({ emailSending: false, emailSuccess: "Email sent successfully!" });
          this.handleCloseEmailModal();
        } catch (error) {
          this.setState({ emailSending: false, emailError: "Failed to send email." });
        }
      };
      private GenerateReport = async () => {
        console.log(this.state, "update  the  state")
        console.log(this.props, "update  the  props")
        const currentUrl = window.location.href;

        let seasonTypes = "";
        const dashboardIndex = currentUrl.indexOf("/dashboard/");
        if (dashboardIndex !== -1) {
          const afterDashboard = currentUrl.substring(dashboardIndex + "/dashboard/".length);
          const parts = afterDashboard.split("/"); // Split by "/"
          seasonTypes = parts[0]; // This is the seasonType
        }

        // Get current year
        const currentYear = new Date().getFullYear();


        const { refreshReports } = this.props;
        this.setState({ showLoader: true }); // Show loader
        try {
          const notificationUpgraded = await this.buildPost<{ sportId: any, coachId: any, schoolId: any, type: any, sessionType: any, year: any }, any>(
            this, "/reports/reportad"
          )({
            schoolId: this.props?.schoolId,
            sportId: -1,
            coachId: -1,
            type: "ad",
            sessionType: seasonTypes,
            year: String(currentYear)

          });
          console.log("notificationUpgraded", notificationUpgraded);

          // Check if response has message property
          if ( notificationUpgraded.status === false) {
            alert(notificationUpgraded.contents);
            // Close modal after user clicks OK on alert
            if (this.props.closeModal) {
              this.props.closeModal();
            }
          }else{
            // Parent data refresh karein
          if (typeof refreshReports === "function") {
            await refreshReports();
          }
          }         
        } catch (error) {
          console.error("Error in notificationUpgraded:", error);
        } finally {
          this.setState({ showLoader: false }); // Hide loader
        }
      }

      // Handle form input change
      // private handleFormChange = (reportIdx: number, fieldName: string, value: any) => {
      //   const { formData } = this.state;
      //   const reportKey = `report_${reportIdx}`;

      //   this.setState({
      //     formData: {
      //       ...formData,
      //       [reportKey]: {
      //         ...formData?.[reportKey],
      //         [fieldName]: value,
      //       },
      //     },
      //   });
      // }

      // Handle print functionality - reusable method
      private handlePrint = (report: any) => {
        const content = document.getElementById(`reprotNewContainer`)?.innerHTML || '';
        const logoUrl = this.props?.schoolData?.gritLogo || gritLogo;
        const schoolName = this.props?.schoolData?.name || this.props.schoolData?.schoolName || '';
        const schoolLogo = this.props?.schoolData?.logo1 || '';
       const seasonLabel = report.season || '';
        console.log("seasonLabel", seasonLabel);
        // Extract header HTML
        const headerLeft = `
          <p class="subtitle">Athletic Program Snapshot - ${seasonLabel}</p>
          <h1>${schoolName}</h1>
        `;
        
        const headerRight = schoolLogo ? `
          <img src="${schoolLogo}" alt="School Logo" style="width: 50px; height: 50px;" />
        ` : '';

        // const printWindow = window.open('', '_blank', 'width=900,height=600');
        
        const printWindow = window.open(
                              '',
                              '_blank',
                              'width=900,height=600,left=0,top=0,screenX=0,screenY=0'
                            );

        if (printWindow) {
          // Grab all CSS <link> and <style> from current page
          const styles = Array.from(document.querySelectorAll('link[rel="stylesheet"], style'))
            .map(style => style.outerHTML)
            .join('\n');

          printWindow.document.write(`
          <html>
            <head>
             
              ${styles}
              
        <style>
              
            body {
                    padding: 0 0 20px 0;
                    color: #000;
                  }

                  .page-break {
                    page-break-after: always;
                  }
                  /* Hide upper header in print window (screen + print) so only report title shows once */
                  .print-header {
                    display: none !important;
                  }
                @media print {
                 
                  body {
                      -webkit-print-color-adjust: exact;
                          print-color-adjust: exact;
                          margin: 0;
                          padding-top: 0 !important;
                          padding-bottom: 20px !important;
                          overflow: visible !important;
                          height: auto !important;
                 }
                 html {
                   overflow: visible !important;
                   height: auto !important;
                 }
                 .print-header {
                   overflow: visible !important;
                   display: none !important;
                 }
                  
              
                 /* Global top spacing: content starts below header on every page (wrapper ensures effect when @page is ignored by PDF/print engine) */
                 .print-content-wrapper {
                   padding-top: 100px !important;
                   margin-top: 0 !important;
                   padding-bottom: 20px !important;
                   align-content: start;
                 }
                 .three-points {
                   padding: 10px 10px !important;
                 }
                .three-points-container > *:first-child {
                  padding-top:20px;
                }
                 .print-content-wrapper > *:first-child {
                   margin-top: 0 !important;
                 }
                 
                 /* Align first page top section closer to fixed header (reduce visible gap) */
                 .print-content-wrapper .top-section {
                   padding-top: 0 !important;
                   margin-top: -20px !important;
                 }
                  
                 /* ROOT CAUSE of blank pages: avoid-break on LARGE wrappers (.main-summary, .card)
                    pushes the whole Highlights/Strengths block to the next page.
                    Keep avoid only on small atomic units (.item, .whiteBox). */
                 .print-content-wrapper .main-summary,
                 .print-content-wrapper .report-card,
                 .print-content-wrapper .card {
                   break-inside: auto !important;
                   page-break-inside: auto !important;
                   margin-top: 0 !important;
                   height: auto !important;
                   max-height: none !important;
                   overflow: visible !important;
                 }
                 .print-content-wrapper .whiteBox,
                 .print-content-wrapper .main-summary .item,
                 .print-content-wrapper .three-points {
                   break-inside: avoid !important;
                   page-break-inside: avoid !important;
                   height: auto !important;
                   max-height: none !important;
                   overflow: visible !important;
                 }
                 .print-content-wrapper .main-summary .card > h5,
                 .print-content-wrapper .card.pad > h5 {
                   page-break-after: avoid !important;
                   break-after: avoid !important;
                 }
                 .print-content-wrapper .conclusion {
                   break-inside: avoid !important;
                   page-break-inside: avoid !important;
                   margin-top: 0 !important;
                   padding-top: 0 !important;
                   page-break-before: auto !important;
                   break-before: auto !important;
                 }
                   .print-content-wrapper .main-summary {
                   align-items: stretch !important;
                   display: grid !important;
                   grid-template-columns: 2.3fr 1fr !important;
                   gap: 10px !important;
                   align-content: start !important;
                   align-items: start !important;
                   margin-top: 0px !important;
                  }
                  
                  .print-content-wrapper .main-summary > .card {
                   align-self: stretch !important;
                   margin-top: 0 !important;
                   margin-bottom: 0 !important;
                   padding: 15px !important;
                   display: flex !important;
                   flex-direction: column !important;
                   vertical-align: top !important;
                   position: relative !important;
                   top: 0 !important;
                   height: 100% !important;
                   align-items: stretch !important;
                  }
                  .print-content-wrapper .main-summary .card:first-child {
                   align-items: stretch !important;
                  }
                  
                  .print-content-wrapper .main-summary .card:first-child {
                   margin-top: 0 !important;
                   padding-top: 15px !important;
                  }
                  .print-content-wrapper .main-summary .card.summary {
                   margin-top: 0 !important;
                   padding-top: 15px !important;
                   gap: 0 !important;
                   row-gap: 0 !important;
                   align-items: flex-start !important;
                  }
             
                  .print-content-wrapper .main-summary .card h5 {
                   margin: 0 0 14px 0 !important;
                   padding: 0 !important;
                   line-height: 1.2 !important;
                           
                  }
                  
                  .print-content-wrapper .main-summary .card.summary h5 {
                   margin: 0 0 0px 0 !important;
                   padding: 0 !important;
                   line-height: 1.2 !important;
                   flex-shrink: 0 !important;
               
                  }
                  
                  .print-content-wrapper .main-summary .list {
                   margin: 0 !important;
                   padding: 0 !important;
                   width: 100% !important;
                  }
                  .print-content-wrapper .main-summary .card:first-child .list {
                   width: 100% !important;
                  }
                  .print-content-wrapper .main-summary .item {
                   width: 100% !important;
                   max-width: 100% !important;
                   align-self: stretch !important;
                  }
                  .print-content-wrapper .main-summary .card:first-child .item {
                   align-items: center !important;
                  }
                  .print-content-wrapper .main-summary .card:first-child .item .icon {
                   align-self: center !important;
                  }
                  
                  .print-content-wrapper .main-summary .card.summary > *:not(h5) {
                   margin-top: 0 !important;
                   padding-top: 0 !important;
                   align-self: flex-start !important;
                  }
                  .print-content-wrapper .main-summary .card.summary p {
                   margin-top: -14px !important;
                   padding-top: 0 !important;
                   margin-bottom: 0 !important;
                   align-self: flex-start !important;
                   position: relative !important;
                  }
                  .print-content-wrapper .continue-development {
                   padding-top: 0 !important;
                   margin-top: 0 !important;
                   border: none !important;
                   overflow: visible !important;
                   align-items: stretch !important;
                 }
                 /* Only Parent Feedback Summary container - remove top space for print */
               
                 .print-content-wrapper .connectedness .tc-header span {
                   color:rgba(0, 0, 0, 1) !important;
                   font-weight: bold !important;
                   opacity:1 !important;
                    letter-spacing: 0;
                  }
           
                 .print-content-wrapper .continue-development .card.pad:first-child {
                   margin-right: 10px !important;
              
                 }
                 .print-content-wrapper .continue-development .card.pad h5 {
                   margin-bottom: 15px !important;
                 }
                 .print-content-wrapper .continue-development .card.pad .resource-container {
                   margin-top: 0 !important;
                 }
                 /* Resources for Growth - title visible, align heading with Continuing Development (print/PDF) */
                 .print-content-wrapper .continue-development .resources-for-growth-heading-wrap {
                   display: block !important;
                   margin-top: 0 !important;
                   margin-bottom: 15px !important;
                   padding-top: 0 !important;
                   padding-bottom: 0 !important;
                   min-height: 0 !important;
                   overflow: visible !important;
                   page-break-after: avoid !important;
                 }
                 .print-content-wrapper .continue-development .resources-for-growth-heading-wrap h5 {
                   display: block !important;
                   visibility: visible !important;
                   margin: 0 !important;
                   padding: 0 !important;
                   width: 100% !important;
                   position: relative !important;
                   z-index: 1 !important;
                   page-break-after: avoid !important;
                 }
                 .print-content-wrapper .continue-development .card.pad .resource-container {
                   margin-top: 0 !important;
                   position: relative !important;
                   z-index: 0 !important;
                 }                 /* Resources for Growth - match normal (screen) CSS 100% for print only */

           
                 
                 .print-content-wrapper .continue-development .card.pad .resource-container .whiteBox p {
                   font-size: 14px !important;
                   line-height: 1.4 !important;
                   color: rgba(0, 0, 0, 1) !important;                  
                   margin: 0 !important;
                   padding: 0 !important;
                   white-space: pre-wrap !important;
                   word-wrap: break-word !important;
                   border: none !important;
                 }
          
                .page-break {
                  display: block;
                  margin-top: 0 !important;
                  margin-bottom: 0 !important;
                  padding-top: 0 !important;
                }
                .page-break + * {
                  margin-top: 0 !important;
                  padding-top: 0 !important;
                }
                
                /* Uniform 20px vertical gap between all section cards; no extra space above first (page-level top spacing only) */
                .print-content-wrapper .main-summary:not(:first-child){
                   margin-top: 10px !important;
                 }
                .print-content-wrapper .report-card:not(:first-child),
                .print-content-wrapper .whiteBox:not(:first-child),
                .print-content-wrapper .card:not(:first-child) {
                  margin-top: 10px !important;
                }
                
                 .print-header {
                    position: fixed !important;
                    top: 0 !important;
                    left: 0 !important;
                    right: 0 !important;
                    width: 100% !important;
                    background-color: transparent !important;
                    overflow: visible !important;
                    clip-path: none !important;

                    -webkit-print-color-adjust: exact !important;
                    print-color-adjust: exact !important;
                    z-index: 1000 !important;
                    display: flex !important;
                    justify-content: space-between !important;
                    align-items: center !important;
                     padding: 10px 20px 10px 20px !important;
                  }
                  .print-header::before {
                    content: '' !important;
                    position: absolute !important;
                    top: 0 !important;
                    left: 0 !important;
                    right: 0 !important;
                    bottom: 0 !important;
                    background-color: #f0f7fb !important;
                    border-radius: 8px !important;
                    z-index: 0 !important;
                    overflow: visible !important;
                    clip-path: none !important;
                    margin: 0 !important;
                  }
                  // .print-header::after {
                  //   content: '' !important;
                  //   position: absolute !important;
                  //   bottom: -8px !important;
                  //   left: 0px !important;
                  //   right: 0px !important;
                  //   height: 8px !important;
                  //   background-color: #fff !important;
                  //   border-radius: 0 !important;
                  //   z-index: 1 !important;
                  //   overflow: visible !important;
                  //   clip-path: none !important;
                  //   margin: 0 !important;
                  // }
                  .print-header > * {
                    position: relative !important;
                    z-index: 2 !important;
                  }
                  .print-header .header-left {
                    display: flex;
                    flex-direction: column; 
                 
                  }
                    .main-summary .card h5,.summry-bottom h5,
                     .header-left .title,.surveyed-score .stat strong,.main-summary .item h4 {
                       font-family: Lato, sans-serif !important;
                     }
                  .print-header .header-left h1 {
                    font-family: Lato, sans-serif !important;
                  }
                  .print-header .header-left p {
                    font-weight: 500;
                    margin-bottom: 0px;
                    text-transform: capitalize;
                    margin: 0 0 0px 0;
                    font-size: 14px;
                    display: block !important;
                    visibility: visible !important;
                    opacity: 1 !important;
                  }
                  .print-header .header-left p.subtitle {
                    display: block !important;
                    visibility: visible !important;
                  }              
                   .header-left .title,
                  .print-header .header-left h1 {
                    margin: 0;
                    width: 100%;
                     font-weight: 700 !important;
                   }
                  .print-header .header-left .title {
                    font-size:32px !important;
                  }
                  .print-header .header-right img {
                    width: 50px;
                    height: 50px;
                  }
                  /* Hide duplicate school name/title inside content; print-header already shows it once */
                  .print-content-wrapper .report-header {
                    display: none !important;
                  }
                  
                  .report-section {
                    break-inside: avoid;
                    page-break-inside: avoid;
                  }
                  
                  .report-section:first-child {
                    margin-top: 0 !important;
                  }
                  
                  .page-break {
                    display: block;
                    height: 0 !important;
                    margin: 0 !important;
                    padding: 0 !important;
                    border: none !important;
                    page-break-after: always;
                    break-after: page;
                    background: transparent !important;
                  }
                  
                  #reprotNewContainer {
                    padding-bottom: 20px;
                  }
                  
                  .footer-logo {
                    position: fixed !important;
                    bottom: -2px !important;
                    left: 0 !important;
                    right: 0 !important;
                    width: 100% !important;
                    text-align: center !important;
                    z-index: 10000 !important;
                    display: flex !important;
                    justify-content: center !important;
                    align-items: center !important;
                    background: #fff !important;
                    border: 10px solid #fff !important;
                    height: 45px;
                  }
                  
                  .footer-logo img {
                    height: 30px !important;
                    width: auto !important;
                    max-width: 100px !important;
                    margin: 0 auto !important;
                    display: block !important;
                  }
                  
                  /* Page-level top margin: reserves space for fixed header so content starts at same Y on every page */
                  @page {
                    margin-top: 40px;
                    margin-bottom: 40px;
                    size: auto;
                    align-content: start;
                  }
                  @page :first {
                    margin-top: 40px;
                    margin-bottom: 40px;
                    align-content: start;
                  }
                  @page :left,
                  @page :right {
                    margin-top: 40px;
                    margin-bottom: 40px;
                    align-content: start;
                  }
                  
                  /* All section cards: 8px radius on all corners, visible at page boundaries */
                  .print-content-wrapper .card,
                  .print-content-wrapper .whiteBox,
                  .print-content-wrapper .connectedness .score,
                  .print-content-wrapper .overallOuter .overall {
                    border-radius: 8px !important;
                  }
                  /* Do NOT keep every top-level section together — that creates blank pages */
                  .print-content-wrapper > * {
                    break-inside: auto !important;
                    page-break-inside: auto !important;
                    height: auto !important;
                    overflow: visible !important;
                  }
                  /* Prevent extra blank page: last element must not force a new page */
                  .print-content-wrapper > *:last-child {
                    page-break-after: auto !important;
                    break-after: auto !important;
                  }
                       
                                              
                  /* Resources for Growth - CSS Grid layout for print page */
                  /* General rule for card.pad.summary h5 - Resources for Growth has specific rule below */
                  .print-content-wrapper .card.pad.summary h5 {
                    margin-bottom: 20px !important;
                    padding-bottom: 10px !important;
                    display: block !important;
                    clear: both !important;
                    position: relative !important;
                    z-index: 10 !important;
                    width: 100% !important;
                    max-width: 100% !important;
                    box-sizing: border-box !important;
                    page-break-after: avoid !important;
                    font-size: 18px !important;
                    font-weight: 600 !important;
                    color: #000 !important;
                
                  }
                  .print-content-wrapper .card.pad.summary {
                    width: 100% !important;
                    max-width: 100% !important;
                    box-sizing: border-box !important;
                  }
                        
                  //   .overallInfo p {
                  //   text-align:justify;
                  // }  
                 
                  .print-content-wrapper .summry-bottom {
                    display: grid !important;
                    grid-template-columns: 1fr 2.5fr !important;
                    align-items: stretch !important;
                    align-content: stretch !important;
                    margin-top: 0px !important;
                    padding-top: 10px !important;
                    gap: 15px !important;
                  }
                  /* When on page 1: no extra top space so gap matches other sections (page 2+ gets 100px below header) */
                  .print-content-wrapper .summry-bottom.on-page-1,
                  .print-content-wrapper .summry-bottom[data-print-page="1"] {
                    padding-top: 0 !important;
                    margin-top: 4px !important;
                  }
                    .print-content-wrapper .summry-bottom > div:first-child {
                        margin-right: 10px !important;
                      }
                       /* Parent Feedback Summary - exact 14px spacing: wrapper padding only */
                       .print-content-wrapper .summry-bottom > .card:first-child {
                      margin-top: 0 !important;
                      padding-top: 0px !important;
                      padding-bottom: 12px !important;
                      // gap: 0 !important;
                      // row-gap: 0 !important;
                      // column-gap: 0 !important;
                    }
                     .print-content-wrapper .summry-bottom h5:first-child {
                       margin-bottom:0px!important;
                     }
                  /* Parent Feedback Summary - main heading; spacing before first white card */
                  .print-content-wrapper .summry-bottom > .card:first-child h5 {
                     margin: 0 !important;
                     margin-top: 0 !important;
                     margin-bottom: 0 !important;
                     padding: 0 !important;
                     padding-top: 0 !important;
                     padding-bottom: 0 !important;
                     position: static !important;
                    //  line-height:1.6rem !important;
                  }
                  /* Parent Feedback Summary - space between main heading and first white card */
                  .print-content-wrapper .summry-bottom > .card:first-child > .whiteBox:first-child,
                  .print-content-wrapper .summry-bottom > .card:first-child .whiteBox:first-of-type {
                     margin-top: 13px !important;
                     margin-bottom: 0 !important;
                     padding-top: 10px !important;
                     padding-bottom: 10px !important;
                      min-height: auto !important;
                      height: auto !important;
                  }
                     .print-content-wrapper .summry-bottom > .card > .whiteBox p {
                      margin-top: 0 !important;
                      margin-bottom: 0 !important;
                      padding-top: 0 !important;
                      padding-bottom: 0 !important;
                      min-height: auto !important;
                      height: auto !important;
                     }
                  /* Both cards equal height; Parent Feedback Summary: gap between white cards */
                  .print-content-wrapper .summry-bottom .card {
                    display: flex !important;
                    flex-direction: column !important;
                    height: 100% !important;
                    align-self: stretch !important;
                    gap: 15px !important;
                  }
                  .print-content-wrapper .summry-bottom > .card:first-child {
                    gap: 0 !important;
                    margin-top: 0 !important;
                    margin-bottom: 0 !important;
                  } 
                  .print-content-wrapper .summry-bottom > .card:not(:first-child) {
                    gap: 0 !important;
                    margin-top: 0 !important;
                    margin-bottom: 0 !important;
                  }
                    .print-content-wrapper .summry-bottom .card h5 {
                     padding-top: 10px !important;
                     margin-top: 0 !important;
                     margin-bottom: 0 !important;
                     padding-bottom: 0 !important;
                     display: block !important;
                     width: 100% !important;
                     text-align: center !important;
                     font-weight: 600 !important;
                     line-height: 1.2 !important;
                    }
                  /* Parents Appreciate / Suggestions for Growth: center align in print */
                  .print-content-wrapper .summry-bottom > .card:first-child .whiteBox h4 {
                    text-align: center !important;
                  }
                    .print-content-wrapper .summry-bottom .tc-header {
                     display: flex !important;
                     justify-content: space-between !important;
                     align-items: center !important;
                     width: 100% !important;
                     margin-top: 0 !important;
                     margin-bottom: 0 !important;
                     padding-top: 14px !important;
                     padding-bottom: 13px !important;
                    }
                    .print-content-wrapper .summry-bottom .tc-header h5 {
                     margin: 0 !important;
                     padding: 0 !important;
                     padding-top: 0 !important;
                     margin-top: 0 !important;
                     display: inline-block !important;
                     width: auto !important;
                     text-align: center !important;
                     font-weight: 600 !important;
                     line-height: 1.4 !important;
                    }
                   .print-content-wrapper .summry-bottom .tc-header span {
                    margin: 0 !important;
                    padding: 0 !important;
                    display: inline-block !important;
                    font-size: 12px !important;
                    text-align: right !important;
                    color: #000 !important;
                   }
                   /* Team Connectedness header helper text: force pure black in print */
                   .print-content-wrapper .summry-bottom .connectedness .tc-header span {
                    color: rgba(0, 0, 0, 1) !important;
                    opacity: 1 !important;
                   }
                  /* Parent Feedback Summary inner cards: compact top/bottom spacing */
                  .print-content-wrapper .summry-bottom .card .whiteBox {
                    margin-bottom: 0 !important;
                    height: auto !important;
                    min-height: auto !important;
                    max-height: none !important;
                    display: flex !important;
                    flex-direction: column !important;
                    padding-top: 0 !important;
                    padding-bottom: 0 !important;
                    border-top-left-radius: 8px !important;
                    border-top-right-radius: 8px !important;
                    align-items: center !important;
                    justify-content: flex-start !important;
                      min-height: auto !important;
                      height: auto !important;
                    gap:5px!important;
                  }
                  .print-content-wrapper .summry-bottom .card .whiteBox p {
                    margin-top: 0 !important;
                    margin-bottom: 0 !important;
                    padding-bottom: 0 !important;
                      min-height: auto !important;
                      height: auto !important;
                    align-items: flex-start !important;
                  }
                  /* Parent Feedback Summary: only these 3 white cards - zero bottom space (override inline minHeight, line-box) */
                  .print-content-wrapper .summry-bottom > .card .whiteBox {
                    padding-bottom: 0 !important;
                    min-height: 0 !important;
                    margin-bottom: 0 !important;
                    height: auto !important;
                  }
                  .print-content-wrapper .summry-bottom > .card .whiteBox p {
                    min-height: 0 !important;
                    margin-bottom: 0 !important;
                    padding-bottom: 0 !important;
                    height: auto !important;
                  }
                  .print-content-wrapper .summry-bottom > .card .whiteBox > *:last-child {
                    min-height: 0 !important;
                    margin-bottom: 0 !important;
                    padding-bottom: 0 !important;
                    height: auto !important;
                  }
                  .summry-bottom .whiteBox:last-child {
                    margin-bottom: 0 !important;
                  }
                     .summry-bottom .card:last-child {
                     position: static !important;       
                      top: auto !important;
                      align-self: start !important;
                      margin-top: 0 !important;
                      height: auto !important;
                      padding-top: 0 !important;
                     }
                                 
                 
                  .continue-development .whiteBox {
                    margin-bottom: 0 !important;
                    padding-bottom: 0 !important;
                    height: auto !important;
                    min-height: auto !important;
                    max-height: none !important;
                    overflow: visible !important;
                    display: flex !important;
                    flex-direction: column !important;
                  }
                  .continue-development .whiteBox:last-child {
                    margin-bottom: 0 !important;
                    padding-bottom: 0 !important;
                  }
          
                
                  .print-content-wrapper .continue-development .whiteBox:not(.resources-growth-box) {
                   margin-bottom: 0 !important;
                    padding-bottom: 0 !important;
                    border: none !important;
                    height: auto !important;
                    min-height: auto !important;
                    max-height: none !important;
                    overflow: visible !important;
                  }
               
                    .print-content-wrapper .continue-development .whiteBox.coachsuggestion {
                    position: relative !important;
                    top: -12px !important;
                    height: auto !important;
                    min-height: auto !important;
                    max-height: none !important;
                    overflow: visible !important;
                    display: block !important;
                    padding-bottom:10px !important;
                  }
                  .print-content-wrapper .continue-development .whiteBox.coachsuggestion p {
                    line-height: 1.6 !important;
                    height: auto !important;
                    min-height: auto !important;
                    max-height: none !important;
                    overflow: visible !important;
                    white-space: pre-wrap !important;
                    word-wrap: break-word !important;
                  }
                               
                      .three-points h6 {
                       margin-bottom: 5px !important;
                        font-size: 14px !important;
                    }
                        .scores .score p,
                     .surveyed-score .stat span {
                       font-size: 11px !important;
                     }
                  
                    .conclusion-infotext p {
                         line-height: 14px;
                          font-size: 10px !important;
                    }
                   
                    .print-content-wrapper .conclusion {
                      margin-top: 0 !important;
                      padding-top: 0 !important;
                    }
                    .print-content-wrapper .conclusion.on-page-2,
                    .print-content-wrapper .conclusion.on-page-3,
                    .print-content-wrapper .conclusion.on-page-4,
                    .print-content-wrapper .conclusion.on-page-5,
                    .print-content-wrapper .conclusion.on-page-6,
                    .print-content-wrapper .conclusion.on-page-7,
                    .print-content-wrapper .conclusion.on-page-8,
                    .print-content-wrapper .conclusion.on-page-9,
                    .print-content-wrapper .conclusion.on-page-10,
                    .print-content-wrapper .conclusion[data-print-page="2"],
                    .print-content-wrapper .conclusion[data-print-page="3"],
                    .print-content-wrapper .conclusion[data-print-page="4"],
                    .print-content-wrapper .conclusion[data-print-page="5"],
                    .print-content-wrapper .conclusion[data-print-page="6"],
                    .print-content-wrapper .conclusion[data-print-page="7"],
                    .print-content-wrapper .conclusion[data-print-page="8"],
                    /* Conclusion on page 3+: same top spacing as page 1 so content starts below header */
                    .print-content-wrapper .conclusion.on-page-3,
                    .print-content-wrapper .conclusion.on-page-4,
                    .print-content-wrapper .conclusion.on-page-5,
                    .print-content-wrapper .conclusion.on-page-6,
                    .print-content-wrapper .conclusion.on-page-7,
                    .print-content-wrapper .conclusion.on-page-8,
                    .print-content-wrapper .conclusion.on-page-9,
                    .print-content-wrapper .conclusion.on-page-10,
                    .print-content-wrapper .conclusion[data-print-page="3"],
                    .print-content-wrapper .conclusion[data-print-page="4"],
                    .print-content-wrapper .conclusion[data-print-page="5"],
                    .print-content-wrapper .conclusion[data-print-page="6"],
                    .print-content-wrapper .conclusion[data-print-page="7"],
                    .print-content-wrapper .conclusion[data-print-page="8"],
                    .print-content-wrapper .conclusion[data-print-page="9"],
                    .print-content-wrapper .conclusion[data-print-page="10"] {
                      padding-top: 100px !important;
                      margin-top: 0 !important;
                    }
                    .print-content-wrapper .conclusion.on-page-2,
                    .print-content-wrapper .conclusion[data-print-page="2"] {
                      padding-top: 100px !important;
                      margin-top: 0 !important;
                    }
                    /* Summry-bottom, main-summary, continue-development on page 2+: same top spacing as page 1 */
                    .print-content-wrapper .summry-bottom.on-page-2,
                    .print-content-wrapper .summry-bottom.on-page-3,
                    .print-content-wrapper .summry-bottom.on-page-4,
                    .print-content-wrapper .summry-bottom.on-page-5,
                    .print-content-wrapper .summry-bottom.on-page-6,
                    .print-content-wrapper .summry-bottom.on-page-7,
                    .print-content-wrapper .summry-bottom.on-page-8,
                    .print-content-wrapper .summry-bottom.on-page-9,
                    .print-content-wrapper .summry-bottom.on-page-10,
                    .print-content-wrapper .summry-bottom[data-print-page="2"],
                    .print-content-wrapper .summry-bottom[data-print-page="3"],
                    .print-content-wrapper .summry-bottom[data-print-page="4"],
                    .print-content-wrapper .summry-bottom[data-print-page="5"],
                    .print-content-wrapper .summry-bottom[data-print-page="6"],
                    .print-content-wrapper .summry-bottom[data-print-page="7"],
                    .print-content-wrapper .summry-bottom[data-print-page="8"],
                    .print-content-wrapper .summry-bottom[data-print-page="9"],
                    .print-content-wrapper .summry-bottom[data-print-page="10"] {
                      padding-top: 100px !important;
                      margin-top: 0 !important;
                    }
                    .print-content-wrapper .main-summary.on-page-2,
                    .print-content-wrapper .main-summary.on-page-3,
                    .print-content-wrapper .main-summary.on-page-4,
                    .print-content-wrapper .main-summary[data-print-page="2"],
                    .print-content-wrapper .main-summary[data-print-page="3"],
                    .print-content-wrapper .main-summary[data-print-page="4"] {
                      padding-top: 100px !important;
                      margin-top: 0 !important;
                    }
                    .print-content-wrapper .continue-development.on-page-2,
                    .print-content-wrapper .continue-development.on-page-3,
                    .print-content-wrapper .continue-development.on-page-4,
                    .print-content-wrapper .continue-development[data-print-page="2"],
                    .print-content-wrapper .continue-development[data-print-page="3"],
                    .print-content-wrapper .continue-development[data-print-page="4"] {
                      padding-top: 100px !important;
                      margin-top: 0 !important;
                    }
                    /* Page 2 only: match top spacing inside cards to Continuing Development / Resources for Growth (page 3) */
                    .print-content-wrapper .summry-bottom.on-page-2 .card .whiteBox,
                    .print-content-wrapper .summry-bottom[data-print-page="2"] .card .whiteBox {
                      padding-top: 30px !important;
                    }
                    /* Parent Feedback Summary: 2nd and 3rd white cards same top padding as first (10px) on page 2 */
                    .print-content-wrapper .summry-bottom.on-page-2 > .card:first-child .whiteBox:not(:first-of-type),
                    .print-content-wrapper .summry-bottom[data-print-page="2"] > .card:first-child .whiteBox:not(:first-of-type) {
                      padding-top: 10px !important;
                    }
                    .print-content-wrapper .summry-bottom.on-page-2 .connectedness .score,
                    .print-content-wrapper .summry-bottom[data-print-page="2"] .connectedness .score {
                      padding: 30px 10px 10px 10px !important;
                    }
                    .print-content-wrapper .summry-bottom.on-page-2 .overallOuter .overall,
                    .print-content-wrapper .summry-bottom[data-print-page="2"] .overallOuter .overall {
                      padding: 30px 5px 10px 5px !important;
                    }
                    .print-content-wrapper .conclusion .card {
                      margin-top: 0 !important;
                      padding-top: 10px !important;
                    }
                    .print-content-wrapper .conclusion .card h5:first-child {
                      margin-top: 0px !important;
                      margin-bottom: 15px !important;
                    }
                    .print-content-wrapper .conclusion .card > .whiteBox {
                      margin-top: 0 !important;
                      padding: 10px !important;
                    }
                    .print-content-wrapper .action-plan-wrapper {
                      padding: 5px 10px !important;
                    }
                    .print-content-wrapper .conclusion .smallcard {
                      padding-top: 10px !important;
                      padding-bottom: 10px !important;
                      padding-left: 5px !important;
                      padding-right: 5px !important;
                      align-items: flex-start !important;
                      justify-content: flex-start !important;
                      min-height: 0 !important;
                    }
                    .print-content-wrapper .conclusion .smallcard > div {
                      margin: 0 !important;
                      padding: 0 !important;
                    }
                    .print-content-wrapper .conclusion .conclusion-infotext {
                      margin-top: 0 !important;
                      padding-top: 0 !important;
                      border-top: none !important;
                    }
                    .print-content-wrapper .conclusion .conclusion-infotext h5 {
                      border-top: none !important;
                    }
                    .print-content-wrapper .conclusion .conclusion-infotext h5::before,
                    .print-content-wrapper .conclusion .conclusion-infotext h5::after {
                      content: none !important;
                      display: none !important;
                    }
                    .print-content-wrapper .conclusion .conclusion-infotext::before {
                      content: none !important;
                      display: none !important;
                    }                                 
                    .print-content-wrapper .summry-bottom  .overall {
                       padding: 20px 5px 10px 5px !important;
                       border-top-left-radius: 8px !important;
                       border-top-right-radius: 8px !important;
                    }
                    .print-content-wrapper .summry-bottom .overallOuter {
                      grid-template-columns: 1.5fr 1fr !important;
                      display: grid !important;
                      align-items: center !important;
                      margin-top: 0px !important;
                      clear: both !important;
                    }                                   
                    .print-content-wrapper .conclusion .timeline {
                      overflow: visible !important;
                      position: relative !important;
                    }
                    /* Hide lower line over Action Plan text only; keep .step::before (line across 3 dots) */
                    .print-content-wrapper .conclusion .timeline::before {
                      content: none !important;
                      display: none !important;
                    }
                    .print-content-wrapper .conclusion .timeline .step {
                      position: relative !important;
                      overflow: visible !important;
                    }
                    .print-content-wrapper .conclusion .timeline .step .dot {
                      position: relative !important;
                      overflow: visible !important;
                    }
                    .print-content-wrapper .conclusion .timeline .step .dot:nth-child(2) {
                      justify-content: center !important;
                    }
                    .print-content-wrapper .conclusion .timeline .step .dot:last-child {
                      justify-content: right !important;
                    }
                    .print-content-wrapper .conclusion .timeline .step .smallcard {
                      position: relative !important;
                      overflow: visible !important;
                    }
                    .print-content-wrapper .conclusion .timeline .step::before {
                      content: "" !important;
                      position: absolute !important;
                      left: 0;
                      right: 0;
                      bottom: 32px !important;
                      // transform: translateY(50%) !important;
                      height: 5px !important;
                      background: #0F3A67 !important;
                      z-index: 1 !important;
                      width: 100% !important;
                    }
                      .print-content-wrapper .conclusion .timeline .step:first-child::before {
                      left:10px !important;
                      }
                      .print-content-wrapper .conclusion .timeline .step:last-child::before {
                      left:-10px !important;
                      }
                    /* Safari-only fix: render one continuous timeline line (avoid segment breaks) */
                    html.safari-print .print-content-wrapper .conclusion .timeline::after {
                      content: "" !important;
                      position: absolute !important;
                      left: 10px !important;
                      right: 10px !important;
                      bottom: 32px !important;
                      height: 5px !important;
                      background: #0F3A67 !important;
                      z-index: 1 !important;
                      width: auto !important;
                    }
                    html.safari-print .print-content-wrapper .conclusion .timeline .step::before {
                      content: none !important;
                      display: none !important;
                    }
                    .scores .score {
                      padding: 5px 5px !important;
                    }
              
                    /* ===============================
                        TEAM CONNECTEDNESS – PRINT FIX
                        =============================== */
                      .print-content-wrapper .summry-bottom .connectedness {
                        display: block !important;
                        width: 100% !important;
                        overflow: visible !important;
                        break-inside: avoid !important;
                        page-break-inside: avoid !important;
                        margin-bottom: 0 !important;
                      }

                      /* Scores grid alignment */
                      .print-content-wrapper .summry-bottom .connectedness .scores {
                        display: grid !important;
                        grid-template-columns: repeat(4, 1fr) !important;
                        gap: 20px !important;
                        align-items: flex-start !important;
                        align-content: start !important;
                        margin-top: 0px !important;
                        margin-bottom: 0 !important;
                        break-inside: avoid !important;
                      }

                      /* Individual score card - equal size for all blue boxes */
                      .print-content-wrapper .summry-bottom .connectedness .score {
                        display: flex !important;
                        flex-direction: column !important;
                        align-items: center !important;
                        justify-content: flex-start !important;
                        width: 100% !important;
                        min-width: 0 !important;
                        max-width: 100% !important;
                        padding: 20px 10px 10px 10px !important;
                        height: auto !important;
                        min-height: 90px !important;
                        break-inside: avoid !important;
                        page-break-inside: avoid !important;
                        border-top-left-radius: 8px !important;
                        border-top-right-radius: 8px !important;
                      }

                      /* Ring size stability - equal size for all rings */
                      .print-content-wrapper .summry-bottom .connectedness .score .ring {
                        width: 80px !important;
                        height: 80px !important;
                        min-width: 80px !important;
                        min-height: 80px !important;
                        max-width: 80px !important;
                        max-height: 80px !important;
                        flex-shrink: 0 !important;
                        margin-bottom: 4px !important;
                        position: relative !important;
                        display: flex !important;
                        align-items: center !important;
                        justify-content: center !important;
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                      }
                      @media print {
                        html.safari-print .print-content-wrapper,
                        html.safari-print .print-content-wrapper * {
                          -webkit-print-color-adjust: exact !important;
                          print-color-adjust: exact !important;
                        }
                      }
                      .score .ring span {
                         color:rgba(0, 0, 0, 1) !important;
                         font-weight: bold !important;
                          font-family: Lato, sans-serif!important;
                         position: absolute !important;
                         top: 50% !important;
                         left: 50% !important;
                         transform: translate(-50%, -50%) !important;
                         margin: 0 !important;
                         z-index: 2 !important;
                      }
                      /* Score text */
                      .print-content-wrapper .summry-bottom .connectedness .score p {
                        font-size: 9px !important;
                        line-height: 1.2 !important;
                        text-align: center !important;
                        margin: 0 !important;
                      }

                    
                      /* Overall blue box - equal height with text; top padding and top border radius */
                      .print-content-wrapper .summry-bottom .overallOuter .overall {
                        height: 100% !important;
                        min-height: 100% !important;
                        display: flex !important;
                        flex-direction: column !important;
                        justify-content: center !important;
                        align-items: center !important;
                        padding: 20px 5px 10px 5px !important;
                        box-sizing: border-box !important;
                        border-top-left-radius: 8px !important;
                        border-top-right-radius: 8px !important;
                      }
                      /* Resources for Growth - Additional print fixes */
                     
                    
                     .print-content-wrapper .resource-container .whiteBox p {
                       line-height: 1.6 !important;
                       padding-bottom: 0 !important;
                       overflow: visible !important;
                       width: 100% !important;
                       max-width: 100% !important;
                       height: auto !important;
                       min-height: auto !important;
                       max-height: none !important;
                       word-wrap: break-word !important;
                       word-break: break-word !important;
                       font-size: 12px !important;
                       color: #000 !important;
                       white-space: pre-wrap !important;
                       font-style: italic !important;
                     }
                      .print-content-wrapper .resource-container .whiteBox h4 {
                        font-size: 14px !important;
                        font-weight: 600 !important;
                        margin: 0 0 12px 0 !important;
                        margin-top: 0 !important;
                        padding: 0px !important;
                        width: 100% !important;
                        max-width: 100% !important;
                        position: relative !important;
                         background: #ffffff !important;
                      background-color: #ffffff !important;
                        word-wrap: break-word !important;
                        overflow-wrap: break-word !important;
                        color: #000 !important;
                        page-break-after: avoid !important;
                      }
                     
                   
                      /* Overall score card stability - equal height */
                      .print-content-wrapper .summry-bottom .overallOuter .card {
                        position: relative !important;
                        top: 0 !important;
                        align-self: stretch !important;
                        height: 100% !important;
                        min-height: 100% !important;
                        display: flex !important;
                        flex-direction: column !important;
                      }

                      /* Prevent absolute / floating issues in print */
                      .print-content-wrapper .connectedness *,
                      .print-content-wrapper .overallOuter * {
                        position: static !important;
                      }
                     .summary p, .summry-bottom p, .main-summary .item p {
                       font-size: 13px !important;
                     }
                     .print-content-wrapper .summary p,
                     .print-content-wrapper .summry-bottom p,
                     .print-content-wrapper .main-summary .item p,
                     .print-content-wrapper .continue-development .item p,
                     .print-content-wrapper .continue-development .whiteBox p,
                     .print-content-wrapper .continue-development .whiteBox.coachsuggestion p,
                     .print-content-wrapper .overallInfo p,
                     .print-content-wrapper .conclusion-infotext p,
                     .print-content-wrapper .overall p {
                       line-height: 1.6 !important;
                     }
                     .print-content-wrapper .main-summary .card:first-child .item p,
                     .print-content-wrapper .continue-development .card .item p {
                       line-height: 1.6 !important;
                     }
                         /* Resources for Growth - equal height four boxes, full content visible */
                         .print-content-wrapper .continue-development .resource-container .whiteBox.resources-growth-box,
                         .print-content-wrapper .continue-development .card.pad .resource-container .whiteBox.resources-growth-box,
                         .print-content-wrapper .resource-container .whiteBox.resources-growth-box {
                      -webkit-print-color-adjust: exact !important;
                      print-color-adjust: exact !important;
                      border: none !important;
                      display: flex !important;
                      flex-direction: column !important;
                      align-items: stretch !important;
                      justify-content: flex-start !important;
                      overflow: visible !important;
                      padding: 0 !important;
                      margin: 0 !important;
                      background: transparent !important;
                      height: 100% !important;
                      align-self: stretch !important;
                     }
                     .print-content-wrapper .summry-bottom .connectedness {
                         margin-top: 0px !important;
                         position: static !important;
                         top: 0px !important;
                         }
                         .print-content-wrapper .summry-bottom .connectedness .tc-header {
                          margin-top: 0 !important;
                          margin-bottom: 0 !important;
                          padding-top: 14px !important;
                          padding-bottom: 13px !important;
                         }
               
              
                         .print-content-wrapper .continue-development .resource-container {
                          display: grid !important;
                          grid-template-columns: repeat(2, 1fr) !important;
                          grid-auto-rows: 1fr !important;
                          align-items: stretch !important;
                          justify-items: stretch !important;
                          position: relative !important;
                          gap: 15px !important;
                          margin-top: 10px !important;
                          clear: both !important;
                          border: none !important;
                          width: 100% !important;
                      }
                      /* No gap between "Resources for Growth" title and the 4 boxes - print only */
                 .print-content-wrapper .continue-development .resources-for-growth-heading-wrap {
                   margin-top: 0 !important;
                    margin-bottom: 15px !important;
                 }
                 /* Resources for Growth: proper text alignment and padding for print only */
                        .print-content-wrapper .continue-development .card.pad .resource-container .whiteBox.resources-growth-box p:not(.title-para) {
                          margin: 0 !important;
                          padding: 0 !important;
                          text-align: left !important;
                          width: 100% !important;
                        }
                           .print-content-wrapper .resource-container .whiteBox.resources-growth-box p.title-para {
                         font-size:18px !important;
                         padding-bottom:10px !important;
                         margin-bottom:10px !important;
                         font-style:normal !important;
                         font-weight:bold !important;
                         font-family: Lato, sans-serif!important;
                         text-align: center !important;
                         margin-top: 0 !important;
                         margin-left: 0 !important;
                         margin-right: 0 !important;
                         padding-left: 0 !important;
                         padding-right: 0 !important;
                         padding-top: 0 !important;
                         width: 100% !important;
                        }
                        .print-content-wrapper .resource-container .whiteBox.resources-growth-box .printclass {
                         position: relative !important;
                         top: 0 !important;
                         left: 0 !important;
                         right: 0 !important;
                         width: 100% !important;
                         max-width: 100% !important;
                         box-sizing: border-box !important;
                         display: flex !important;
                         flex-direction: column !important;
                         align-items: flex-start !important;
                         justify-content: flex-start !important;
                         height: 100% !important;
                         min-height: 100% !important;
                         max-height: none !important;
                         overflow: visible !important;
                         padding: 15px 15px 15px 15px !important;
                         margin: 0 !important;
                         background: #fff !important;
                         border-radius: 8px !important;
                         -webkit-print-color-adjust: exact !important;
                         print-color-adjust: exact !important;
                         border: none !important;
                         text-align: left !important;
                         vertical-align: top !important;
                         }
                        .print-content-wrapper .resource-container .whiteBox.resources-growth-box .printclass p:not(.title-para) {
                         height: auto !important;
                         min-height: auto !important;
                         max-height: none !important;
                         overflow: visible !important;
                         display: block !important;
                         text-align: left !important;
                         width: 100% !important;
                         margin: 0 !important;
                         padding: 0 !important;
                         line-height: 1.5 !important;
                         word-wrap: break-word !important;
                         word-break: break-word !important;
                         white-space: pre-wrap !important;
                         }
                       
                      body .print-content-wrapper .summry-bottom .card.pad h5 {
                          font-size: 22px !important;
                        }
                          .conclusion h5:first-child {
                            margin-bottom:0 !important;
                            line-height:1.2;
                          }
                       /* Parents appreciates / Suggestion for growth: mandatory center align */
                       .summry-bottom > .card:first-child .whiteBox:nth-of-type(1) h4,
                       .summry-bottom > .card:first-child .whiteBox:nth-of-type(2) h4 {
                         text-align: center !important;
                       }
                       .summry-bottom .whiteBox h4 {
                         text-align:center !important;
                         font-weight:normal;
                         margin-top: 0 !important;
                         margin-bottom: 4px !important;
                         font-size: 16px !important;
                       } 
                 
                         .print-content-wrapper .continue-development {
                         grid-template-columns: 1fr 1fr !important;
                          gap: 3px !important;
                          align-items: stretch !important;
                        } 
                          .print-content-wrapper .continue-development .card.pad:first-child h5 {
                            padding-top:15px !important;
                          }
                           .print-content-wrapper .continue-development .card.pad:last-child {
                            position: relative !important;
                            top: 0 !important;
                            margin-top: 0 !important;
                            padding-top: 15px !important;
                           }
                          .print-content-wrapper .action-plan-wrapper h5 {
                            margin-top: 5px !important;
                            margin-bottom: 5px !important;
                          }
                         .print-content-wrapper .continue-development .card.pad:first-child {
                           position: relative !important;
                           background-color: transparent !important;
                           border-top-left-radius: 8px !important;
                           border-top-right-radius: 8px !important;
                           border-bottom-left-radius: 8px !important;
                           border-bottom-right-radius: 8px !important;ust remove the spa
                           overflow: visible !important;
                        }
                         .print-content-wrapper .continue-development .card.pad:first-child::before {
                           content: '' !important;
                           position: absolute !important;
                           top: 0 !important;
                           left: 0 !important;
                           right: 0 !important;
                           bottom: 0 !important;
                           background-color: #f0f7fb !important;
                           border-radius: 8px !important;
                           z-index: 0 !important;
                         }
                         .print-content-wrapper .continue-development .card.pad:first-child > * {
                           position: relative !important;
                           z-index: 1 !important;
                         }

                  body {
                    overflow: visible !important;
                    height: auto !important;
                  }
                  html {
                    overflow: visible !important;
                    height: auto !important;
                  }
                }
             
              </style>
            </head>
            <body>
              <div class="print-header">
                <div class="header-left">
                  ${headerLeft}
                </div>
                ${headerRight ? `<div class="header-right">${headerRight}</div>` : ''}
              </div>
              <div class="print-content-wrapper">
                ${content}
              </div>
              <div class="footer-logo">
                <img src="${logoUrl}" alt="Grit Leadership Logo" />
              </div>
              <script>
                (function() {
                  if (typeof Element.prototype.closest !== 'function') {
                    Element.prototype.closest = function(s) {
                      var el = this; while (el) {
                        if (el.nodeType === 1 && (el.matches ? el.matches(s) : el.msMatchesSelector(s))) return el;
                        el = el.parentElement;
                      }
                      return null;
                    };
                  }
                  function adjustResourceBoxes() {
                    var whiteBoxes = document.querySelectorAll('.resource-container .whiteBox');
                    for (var i = 0; i < whiteBoxes.length; i++) {
                      var box = whiteBoxes[i];
                      if (box && !(box.closest && box.closest('.continue-development'))) {
                        box.style.setProperty('height', 'auto', 'important');
                        box.style.setProperty('min-height', 'auto', 'important');
                        box.style.setProperty('max-height', 'none', 'important');
                        box.style.setProperty('overflow', 'visible', 'important');
                      }
                    }
                  }
                  function adjustGrowthBoxesEqualHeight() {
                    var containers = document.querySelectorAll('.continue-development .resource-container');
                    for (var c = 0; c < containers.length; c++) {
                      var container = containers[c];
                      var boxes = container.querySelectorAll('.whiteBox.resources-growth-box');
                      if (boxes.length !== 4) continue;
                      
                      // Ensure grid uses 1fr for equal row heights
                      container.style.setProperty('grid-auto-rows', '1fr', 'important');
                      
                      // Remove any margin/padding that could cause misalignment and ensure stretch behavior
                      for (var b = 0; b < boxes.length; b++) {
                        var w = boxes[b];
                        w.style.setProperty('margin', '0', 'important');
                        w.style.setProperty('padding', '0', 'important');
                        w.style.setProperty('height', '100%', 'important');
                        w.style.setProperty('align-self', 'stretch', 'important');
                        w.style.setProperty('display', 'flex', 'important');
                        w.style.setProperty('flex-direction', 'column', 'important');
                        w.style.setProperty('justify-content', 'flex-start', 'important');
                        
                        // Ensure inner printclass is top-aligned
                        var printclass = w.querySelector('.printclass');
                        if (printclass) {
                          printclass.style.setProperty('height', '100%', 'important');
                          printclass.style.setProperty('display', 'flex', 'important');
                          printclass.style.setProperty('flex-direction', 'column', 'important');
                          printclass.style.setProperty('justify-content', 'flex-start', 'important');
                          printclass.style.setProperty('width', '100%', 'important');
                        }
                      }
                    }
                  }
                  adjustResourceBoxes();
                  adjustGrowthBoxesEqualHeight();
                  if (document.readyState === 'loading') {
                    document.addEventListener('DOMContentLoaded', function() { adjustResourceBoxes(); adjustGrowthBoxesEqualHeight(); });
                  }
                  window.addEventListener('load', function() {
                    adjustResourceBoxes();
                    adjustGrowthBoxesEqualHeight();
                  });
                  setTimeout(function() { adjustResourceBoxes(); adjustGrowthBoxesEqualHeight(); }, 50);
                  setTimeout(function() { adjustResourceBoxes(); adjustGrowthBoxesEqualHeight(); }, 100);
                  setTimeout(adjustGrowthBoxesEqualHeight, 200);
                  setTimeout(adjustGrowthBoxesEqualHeight, 400);
                })();
              </script>
            </body>
          </html>
        `);

          printWindow.document.close();
          const printUA = window.navigator.userAgent || "";
          const isSafariPrint =
            /Safari/i.test(printUA) &&
            !/Chrome|Chromium|CriOS|Edg|OPR|Firefox|FxiOS/i.test(printUA);
          if (isSafariPrint) {
            printWindow.document.documentElement.classList.add("safari-print");
          }
          printWindow.focus();

          // Add page-wise classes to elements for print styling (e.g., on-page-1, on-page-2, on-page-3)
          const addPageWiseClassesForPrint = (win: Window) => {
            const doc = win.document;
            const wrapper = doc.querySelector('.print-content-wrapper');
            if (!wrapper) {
              return;
            }
            const wr = wrapper.getBoundingClientRect();
            const pageHeight = Math.max(900, Math.min(1050, (win.innerHeight || 960) - 180)) || 960;
            const children = Array.from(wrapper.children);
            for (const child of children) {
              const el = child as HTMLElement;
              if (!el) {
                continue;
              }
              const cr = el.getBoundingClientRect();
              const elementTop = cr.top - wr.top;
              const pageNumber = Math.floor(elementTop / pageHeight) + 1;
              el.classList.remove('on-page-1', 'on-page-2', 'on-page-3', 'on-page-4', 'on-page-5', 'on-page-6', 'on-page-7', 'on-page-8', 'on-page-9', 'on-page-10');
              el.classList.add(`on-page-${pageNumber}`);
              el.setAttribute('data-print-page', pageNumber.toString());
            }
            const majorSections = doc.querySelectorAll('.main-summary, .summry-bottom, .continue-development, .conclusion, .report-card, .whiteBox, .card');
            majorSections.forEach((section: Element) => {
              const el = section as HTMLElement;
              if (!el || !wrapper.contains(el)) {
                return;
              }
              const sr = el.getBoundingClientRect();
              const sectionTop = sr.top - wr.top;
              const pageNumber = Math.floor(sectionTop / pageHeight) + 1;
              el.classList.remove('on-page-1', 'on-page-2', 'on-page-3', 'on-page-4', 'on-page-5', 'on-page-6', 'on-page-7', 'on-page-8', 'on-page-9', 'on-page-10');
              el.classList.add(`on-page-${pageNumber}`);
              el.setAttribute('data-print-page', pageNumber.toString());
            });
          };

          // Page 2+: same top spacing as page 1 so content never hides behind header
          const applyConclusionPaddingForPrint = (win: Window) => {
            const doc = win.document;
            const wrapper = doc.querySelector('.print-content-wrapper');
            if (!wrapper) {
              return;
            }
            const wr = wrapper.getBoundingClientRect();
            const pageHeight = Math.max(900, Math.min(1050, (win.innerHeight || 960) - 180)) || 960;
            doc.querySelectorAll('.conclusion').forEach((el: Element) => {
              const c = el as HTMLElement;
              if (!c) {
                return;
              }
              const cr = c.getBoundingClientRect();
              const top = cr.top - wr.top;
              const pageNum = Math.floor(top / pageHeight) + 1;
              if (pageNum >= 2) {
                c.style.setProperty('padding-top', '100px', 'important');
                c.style.setProperty('margin-top', '0', 'important');
              } else {
                c.style.setProperty('padding-top', '0', 'important');
                c.style.setProperty('margin-top', '0', 'important');
              }
            });
          };

          const applySummryBottomPaddingForPrint = (win: Window) => {
            const summryBottom = win.document.querySelector('.summry-bottom') as HTMLElement;
            if (!summryBottom) {
              return;
            }
            const pageAttr = summryBottom.getAttribute('data-print-page');
            const pageNum = pageAttr ? parseInt(pageAttr, 10) : 1;
            if (pageNum >= 3) {
              summryBottom.style.setProperty('padding-top', '100px', 'important');
              summryBottom.style.setProperty('margin-top', '0', 'important');
            } else {
              summryBottom.style.setProperty('padding-top', '0', 'important');
              summryBottom.style.setProperty('margin-top', '15px', 'important');
            }
          };

          // Adjust print layout
          const adjustPrintTextareas = () => {
            // Resource containers: only touch Resources for Growth section (no spacing/layout overrides)
            const resourceContainers = printWindow.document.querySelectorAll('.continue-development .resource-container');
            resourceContainers.forEach((container: any) => {
              container.style.setProperty('display', 'grid', 'important');
              container.style.setProperty('grid-template-columns', 'repeat(2, 1fr)', 'important');
            });
            
            // Resources for Growth card only: align heading with Continuing Development in print/PDF
            const rfGCard = printWindow.document.querySelector('.continue-development .card.pad:last-child') as HTMLElement;
            const rfGHeadingWrap = printWindow.document.querySelector('.continue-development .resources-for-growth-heading-wrap') as HTMLElement;
            if (rfGCard) {
              rfGCard.style.setProperty('padding-top', '15px', 'important');
            }
            if (rfGHeadingWrap) {
              rfGHeadingWrap.style.setProperty('margin-top', '0', 'important');
            }
            // Fix h5 - Resources for Growth (no space between heading and boxes)
            const resourceSectionTitles = printWindow.document.querySelectorAll('.continue-development .card.pad.summary h5, .card.pad.summary h5, .continue-development .resources-for-growth-heading-wrap h5');
            resourceSectionTitles.forEach((h5: any) => {
              if (h5 && h5.textContent && h5.textContent.trim() === 'Resources for Growth') {
                h5.style.setProperty('margin', '0', 'important');
                h5.style.setProperty('margin-bottom', '0', 'important');
                h5.style.setProperty('padding', '0', 'important');
                h5.style.setProperty('white-space', 'nowrap', 'important');
              }
            });
            // Resources for Growth: ensure grid stretch behavior and remove any margin/padding causing misalignment
            const growthContainers = printWindow.document.querySelectorAll('.continue-development .resource-container');
            for (const container of Array.from(growthContainers) as HTMLElement[]) {
              const boxes = container.querySelectorAll('.whiteBox.resources-growth-box');
              if (!boxes || boxes.length !== 4) {
                continue;
              }
              
              // Ensure grid uses 1fr for equal row heights
              container.style.setProperty('grid-auto-rows', '1fr', 'important');
              
              // Remove any margin/padding that could cause misalignment and ensure stretch behavior
              for (const whiteBox of Array.from(boxes) as HTMLElement[]) {
                if (whiteBox) {
                  whiteBox.style.setProperty('margin', '0', 'important');
                  whiteBox.style.setProperty('padding', '0', 'important');
                  whiteBox.style.setProperty('height', '100%', 'important');
                  whiteBox.style.setProperty('align-self', 'stretch', 'important');
                  whiteBox.style.setProperty('display', 'flex', 'important');
                  whiteBox.style.setProperty('flex-direction', 'column', 'important');
                  whiteBox.style.setProperty('justify-content', 'flex-start', 'important');
                  
                  // Ensure inner printclass div fills the card and is top-aligned
                  const printclass = whiteBox.querySelector('.printclass') as HTMLElement;
                  if (printclass) {
                    printclass.style.setProperty('height', '100%', 'important');
                    printclass.style.setProperty('display', 'flex', 'important');
                    printclass.style.setProperty('flex-direction', 'column', 'important');
                    printclass.style.setProperty('justify-content', 'flex-start', 'important');
                    printclass.style.setProperty('width', '100%', 'important');
                  }
                }
              }
            }
            // Other resource whiteBoxes (outside continue-development) - expand to content
            const otherResourceBoxes = printWindow.document.querySelectorAll('.resource-container .whiteBox');
            otherResourceBoxes.forEach((whiteBox: any) => {
              if (whiteBox && !whiteBox.closest('.continue-development')) {
                whiteBox.style.setProperty('height', 'auto', 'important');
                whiteBox.style.setProperty('overflow', 'visible', 'important');
              }
            });
            
            // Fix Parent Feedback Summary and Team Connectedness - equal height columns
            const summryBottomSection = printWindow.document.querySelector('.summry-bottom') as any;
            if (summryBottomSection) {
              summryBottomSection.style.setProperty('display', 'grid', 'important');
              summryBottomSection.style.setProperty('grid-template-columns', '1fr 1.7fr', 'important');
              summryBottomSection.style.setProperty('align-items', 'stretch', 'important');
              summryBottomSection.style.setProperty('align-content', 'stretch', 'important');
              summryBottomSection.style.setProperty('gap', '0', 'important');
            }
            
            // Make both cards equal height
            const summryBottomCards = printWindow.document.querySelectorAll('.summry-bottom .card');
            summryBottomCards.forEach((card: any) => {
              if (card) {
                card.style.setProperty('display', 'flex', 'important');
                card.style.setProperty('flex-direction', 'column', 'important');
                card.style.setProperty('height', '100%', 'important');
                card.style.setProperty('align-self', 'stretch', 'important');
              }
            });
            
            // Fix Parent Feedback Summary and Team Connectedness titles alignment
            const summryBottomH5s = printWindow.document.querySelectorAll('.summry-bottom .card h5');
            summryBottomH5s.forEach((h5: any) => {
              if (h5) {
                h5.style.setProperty('padding-top', '10px', 'important');
                h5.style.setProperty('margin-top', '0', 'important');
                h5.style.setProperty('margin-bottom', '0', 'important');
                h5.style.setProperty('padding-bottom', '0', 'important');
                h5.style.setProperty('display', 'block', 'important');
                h5.style.setProperty('width', '100%', 'important');
                h5.style.setProperty('text-align', 'left', 'important');
                h5.style.setProperty('font-weight', '600', 'important');
                h5.style.setProperty('font-size', '20px', 'important');
                h5.style.setProperty('line-height', '1.4', 'important');
              }
            });
            
            // Fix Team Connectedness header layout
            const tcHeaders = printWindow.document.querySelectorAll('.summry-bottom .tc-header');
            tcHeaders.forEach((header: any) => {
              if (header) {
                header.style.setProperty('display', 'flex', 'important');
                header.style.setProperty('justify-content', 'space-between', 'important');
                header.style.setProperty('align-items', 'baseline', 'important');
                header.style.setProperty('width', '100%', 'important');
                header.style.setProperty('margin-bottom', '0', 'important');
                header.style.setProperty('padding-top', '10px', 'important');
                
                const h5 = header.querySelector('h5');
                if (h5) {
                  h5.style.setProperty('margin', '0', 'important');
                  h5.style.setProperty('padding', '0', 'important');
                  h5.style.setProperty('display', 'inline-block', 'important');
                  h5.style.setProperty('width', 'auto', 'important');
                  h5.style.setProperty('text-align', 'left', 'important');
                }
                
                const span = header.querySelector('span');
                if (span) {
                  span.style.setProperty('margin', '0', 'important');
                  span.style.setProperty('padding', '0', 'important');
                  span.style.setProperty('display', 'inline-block', 'important');
                  span.style.setProperty('font-size', '12px', 'important');
                  span.style.setProperty('text-align', 'right', 'important');
                  span.style.setProperty('color', '#666', 'important');
                }
              }
            });
            
            // Adjust Parent Feedback Summary boxes (summry-bottom .whiteBox) to match content height
            const parentFeedbackBoxes = printWindow.document.querySelectorAll('.summry-bottom .whiteBox');
            const parentFeedbackCard = printWindow.document.querySelector('.summry-bottom > .card:first-child');
            parentFeedbackBoxes.forEach((box: any) => {
              if (box) {
                box.style.setProperty('border-top-left-radius', '8px', 'important');
                box.style.setProperty('border-top-right-radius', '8px', 'important');
                const isParentFeedbackBox = parentFeedbackCard && parentFeedbackCard.contains(box);
                // Parent Feedback Summary inner 3 cards only: no bottom padding/space, and no fixed height (so no extra white space)
                if (isParentFeedbackBox) {
                  box.style.setProperty('padding-bottom', '15px', 'important');
                  box.style.setProperty('height', 'auto', 'important');
                  box.style.setProperty('min-height', '0', 'important');
                  box.style.setProperty('max-height', 'none', 'important');
                  const p = box.querySelector('p');
                  if (p) {
                    (p as HTMLElement).style.setProperty('min-height', '0', 'important');
                    (p as HTMLElement).style.setProperty('margin-bottom', '0', 'important');
                    (p as HTMLElement).style.setProperty('padding-bottom', '0', 'important');
                    (p as HTMLElement).style.setProperty('line-height', '1.4', 'important');
                  }
                }
                if (!isParentFeedbackBox) {
                  // Reset box height for non–Parent Feedback boxes
                  box.style.setProperty('height', 'auto', 'important');
                  box.style.setProperty('min-height', 'auto', 'important');
                  box.style.setProperty('max-height', 'none', 'important');
                }
                
                // Adjust textarea inside the box (Parent Feedback cards use p, not textarea)
                const textarea = box.querySelector('textarea');
                if (textarea) {
                  textarea.style.setProperty('height', 'auto', 'important');
                  textarea.style.setProperty('min-height', 'auto', 'important');
                  textarea.style.setProperty('max-height', 'none', 'important');
                  const scrollHeight = textarea.scrollHeight || textarea.clientHeight || 0;
                  if (scrollHeight > 0) {
                    textarea.style.setProperty('height', scrollHeight + 'px', 'important');
                  }
                }
                
                // Set box height to match content only for non–Parent Feedback boxes (avoid extra white space in print)
                if (!isParentFeedbackBox) {
                  const boxHeight = box.scrollHeight || box.offsetHeight || 0;
                  if (boxHeight > 0) {
                    box.style.setProperty('height', boxHeight + 'px', 'important');
                    box.style.setProperty('min-height', boxHeight + 'px', 'important');
                  }
                }
              }
            });
            
            // Team Connectedness: top border radius on score cards and blue overall card (padding-top from CSS, page-2-only 30px)
            const tcScoreCards = printWindow.document.querySelectorAll('.summry-bottom .connectedness .score');
            tcScoreCards.forEach((el: any) => {
              if (el) {
                el.style.setProperty('border-top-left-radius', '8px', 'important');
                el.style.setProperty('border-top-right-radius', '8px', 'important');
              }
            });
            if (isSafariPrint) {
              const ringEls = printWindow.document.querySelectorAll('.summry-bottom .connectedness .score .ring');
              ringEls.forEach((ringEl: Element) => {
                const ring = ringEl as HTMLElement;
                if (!ring || ring.getAttribute('data-safari-donut') === '1') {
                  return;
                }
                const valueNode = ring.querySelector('span') as HTMLElement | null;
                const scoreValue = Number((valueNode?.textContent || "0").trim());
                const clamped = Math.max(0, Math.min(10, isNaN(scoreValue) ? 0 : scoreValue));
                const size = 80;
                const radius = 32;
                const strokeWidth = 14;
                const circumference = 2 * Math.PI * radius;
                const dashOffset = circumference * (1 - clamped / 10);

                const svgNS = 'http://www.w3.org/2000/svg';
                const svg = printWindow.document.createElementNS(svgNS, 'svg');
                svg.setAttribute('width', String(size));
                svg.setAttribute('height', String(size));
                svg.setAttribute('viewBox', `0 0 ${size} ${size}`);
                svg.setAttribute('aria-hidden', 'true');
                (svg as any).style.position = 'absolute';
                (svg as any).style.inset = '0';

                const track = printWindow.document.createElementNS(svgNS, 'circle');
                track.setAttribute('cx', String(size / 2));
                track.setAttribute('cy', String(size / 2));
                track.setAttribute('r', String(radius));
                track.setAttribute('fill', 'none');
                track.setAttribute('stroke', '#e6edf4');
                track.setAttribute('stroke-width', String(strokeWidth));

                const progress = printWindow.document.createElementNS(svgNS, 'circle');
                progress.setAttribute('cx', String(size / 2));
                progress.setAttribute('cy', String(size / 2));
                progress.setAttribute('r', String(radius));
                progress.setAttribute('fill', 'none');
                progress.setAttribute('stroke', '#0b3a6f');
                progress.setAttribute('stroke-width', String(strokeWidth));
                progress.setAttribute('stroke-dasharray', `${circumference} ${circumference}`);
                progress.setAttribute('stroke-dashoffset', String(dashOffset));
                // Safari-only print donut: start at right-center (3 o'clock), clockwise.
                // Default SVG circle stroke starts at 3 o'clock, so no rotation is applied.

                svg.appendChild(track);
                svg.appendChild(progress);
                ring.insertBefore(svg, ring.firstChild);

                ring.style.setProperty('background', 'none', 'important');
                ring.style.setProperty('position', 'relative', 'important');
                ring.style.setProperty('display', 'flex', 'important');
                ring.style.setProperty('align-items', 'center', 'important');
                ring.style.setProperty('justify-content', 'center', 'important');
                ring.setAttribute('data-safari-donut', '1');

                if (valueNode) {
                  valueNode.style.setProperty('position', 'absolute', 'important');
                  valueNode.style.setProperty('top', '50%', 'important');
                  valueNode.style.setProperty('left', '50%', 'important');
                  valueNode.style.setProperty('transform', 'translate(-50%, -50%)', 'important');
                  valueNode.style.setProperty('margin', '0', 'important');
                  valueNode.style.setProperty('z-index', '2', 'important');
                }
              });
            }
            const overallCard = printWindow.document.querySelector('.summry-bottom .overallOuter .overall') as HTMLElement;
            if (overallCard) {
              overallCard.style.setProperty('border-top-left-radius', '8px', 'important');
              overallCard.style.setProperty('border-top-right-radius', '8px', 'important');
            }
            
            // Fix Conclusion section - 100px space only when on 3rd+ page; 15px on page 2; 0 on page 1 (print only)
            const conclusionSections = printWindow.document.querySelectorAll('.conclusion');
            conclusionSections.forEach((conclusion: any) => {
              if (conclusion) {
                conclusion.style.setProperty('margin-top', '0', 'important');
                conclusion.style.setProperty('page-break-before', 'auto', 'important');
                conclusion.style.setProperty('break-before', 'auto', 'important');
                conclusion.style.setProperty('padding-top', '0', 'important');
                const conclusionCard = conclusion.querySelector('.card');
                if (conclusionCard) {
                  conclusionCard.style.setProperty('margin-top', '-85px', 'important');
                  conclusionCard.style.setProperty('margin-bottom', '0', 'important');
                  conclusionCard.style.setProperty('padding-top', '10px', 'important');
                  const conclusionHeading = conclusionCard.querySelector('h5:first-child');
                  if (conclusionHeading) {
                    (conclusionHeading as HTMLElement).style.setProperty('margin-top', '0', 'important');
                    (conclusionHeading as HTMLElement).style.setProperty('margin-bottom', '15px', 'important');
                  }
                  const conclusionFirstWhiteBox = conclusionCard.querySelector(':scope > .whiteBox');
                  if (conclusionFirstWhiteBox) {
                    (conclusionFirstWhiteBox as HTMLElement).style.setProperty('margin-top', '0', 'important');
                  }
                }
                const conclusionInfo = conclusion.querySelector('.conclusion-infotext');
                if (conclusionInfo) {
                  conclusionInfo.style.setProperty('margin-top', '0', 'important');
                  conclusionInfo.style.setProperty('padding-top', '0', 'important');
                }
              }
            });
            addPageWiseClassesForPrint(printWindow);
            applyConclusionPaddingForPrint(printWindow);
            applySummryBottomPaddingForPrint(printWindow);
            setTimeout(() => { 
              addPageWiseClassesForPrint(printWindow);
              applyConclusionPaddingForPrint(printWindow); 
              applySummryBottomPaddingForPrint(printWindow);
            }, 50);
            setTimeout(() => { 
              addPageWiseClassesForPrint(printWindow);
              applyConclusionPaddingForPrint(printWindow); 
              applySummryBottomPaddingForPrint(printWindow);
            }, 150);
            setTimeout(() => { 
              addPageWiseClassesForPrint(printWindow);
              applyConclusionPaddingForPrint(printWindow); 
              applySummryBottomPaddingForPrint(printWindow);
            }, 300);
            
            // Adjust Coach Suggestions for AD Improvement boxes (.continue-development .whiteBox) to show full data
            // Exclude resources-growth-box to avoid interfering with equal height logic
            const coachSuggestionBoxes = printWindow.document.querySelectorAll('.continue-development .whiteBox:not(.resources-growth-box)');
            coachSuggestionBoxes.forEach((box: any) => {
              if (box) {
                // Reset box height
                box.style.setProperty('height', 'auto', 'important');
                box.style.setProperty('min-height', 'auto', 'important');
                box.style.setProperty('max-height', 'none', 'important');
                box.style.setProperty('overflow', 'visible', 'important');
                
                // Adjust textarea inside the box
                const textarea = box.querySelector('textarea');
                if (textarea) {
                  // Remove all constraints
                  textarea.style.setProperty('height', 'auto', 'important');
                  textarea.style.setProperty('min-height', 'auto', 'important');
                  textarea.style.setProperty('max-height', 'none', 'important');
                  textarea.style.setProperty('overflow', 'visible', 'important');
                  textarea.style.setProperty('overflow-y', 'visible', 'important');
                  textarea.style.setProperty('overflow-x', 'visible', 'important');
                  
                  // Force reflow to get accurate scrollHeight
                  if (textarea.offsetHeight) {
                    // Reflow triggered
                  }
                  
                  // Set height to actual content height
                  const scrollHeight = textarea.scrollHeight || textarea.clientHeight || 0;
                  if (scrollHeight > 0) {
                    textarea.style.setProperty('height', scrollHeight + 'px', 'important');
                  }
                }
                
                // Let box height grow with content (avoid cutting off text on print)
                box.style.setProperty('height', 'auto', 'important');
                box.style.setProperty('min-height', 'auto', 'important');
                if (box.offsetHeight) {
                  // Reflow triggered
                }
                const boxHeight = box.scrollHeight || box.offsetHeight || 0;
                if (boxHeight > 0) {
                  // Keep auto so content is never cut off; optional: box.style.setProperty('min-height', boxHeight + 'px', 'important');
                  box.style.setProperty('max-height', 'none', 'important');
                  box.style.setProperty('overflow', 'visible', 'important');
                }
              }
            });

            // Remove trailing page breaks so no extra blank page is shown
            const wrapper = printWindow.document.querySelector('.print-content-wrapper');
            if (wrapper) {
              let last = wrapper.lastElementChild;
              while (last && (
                (last.classList && last.classList.contains('page-break')) ||
                (last instanceof HTMLElement && (last.style.pageBreakAfter === 'always' || last.style.breakAfter === 'page'))
              )) {
                last.remove();
                last = wrapper.lastElementChild;
              }
              // Force last element to not add a page break after (overrides any CSS class)
              if (last && last instanceof HTMLElement) {
                last.style.setProperty('page-break-after', 'auto', 'important');
                last.style.setProperty('break-after', 'auto', 'important');
              }
            }

            // Hide sections that have a header but no text content after the header (no extra page for header-only)
            const hideEmptySections = (doc: Document) => {
              const textOutside = (container: Element, exclude: Element): string => {
                let s = '';
                const walk = (node: Node) => {
                  if (node === exclude || (exclude.contains && exclude.contains(node))) {
                    return;
                  }
                  if (node.nodeType === Node.TEXT_NODE) {
                    s += (node.textContent || '');
                  }
                  node.childNodes.forEach(walk);
                };
                walk(container);
                return s.trim();
              };
              doc.querySelectorAll('.main-summary .card, .summry-bottom .card, .continue-development .card, .conclusion .card').forEach((card: Element) => {
                const c = card as HTMLElement;
                const header = c.querySelector('h4, h5, h6, .tc-header');
                if (!header) {
                  return;
                }
                if (!textOutside(c, header)) {
                  c.style.setProperty('display', 'none', 'important');
                }
              });
            };
            hideEmptySections(printWindow.document);
          };
          
          // Run multiple times to ensure Resources for Growth textareas are properly adjusted
          setTimeout(adjustPrintTextareas, 100);
          setTimeout(adjustPrintTextareas, 200);
          setTimeout(adjustPrintTextareas, 300);
          setTimeout(adjustPrintTextareas, 500);
          setTimeout(adjustPrintTextareas, 800);
          setTimeout(adjustPrintTextareas, 1000);

          // Wait longer so layout is ready on all platforms (Windows/Mac/Linux) before print
          setTimeout(() => {
            adjustPrintTextareas();
            setTimeout(() => {
              adjustPrintTextareas();
              addPageWiseClassesForPrint(printWindow);
              applyConclusionPaddingForPrint(printWindow);
              applySummryBottomPaddingForPrint(printWindow);
              setTimeout(() => {
                addPageWiseClassesForPrint(printWindow);
                applyConclusionPaddingForPrint(printWindow);
                applySummryBottomPaddingForPrint(printWindow);
                printWindow.print();
              }, 300);
            }, 100);
          }, 1200);
        }
      }

      // Dynamically build editable report payload from state - ONLY editable fields
      private buildEditableReportPayload = (report: any, reportIdx: number) => {
        const reportKey = `report_${reportIdx}`;
        const formFieldData: any = this.state.formData?.[reportKey] || {};

        // Build payload with ONLY editable fields
        const editableReport: any = {
          id: report.id,
          type: "ad",
          audit_details: report.audit_details || {},
            key_strengths: report.key_strengths || [],
            improvement_opportunities: report.improvement_opportunities || [],
            team_connectedness: report.team_connectedness || {},
            suggestions_for_growth: report.suggestions_for_growth || {},
            sport_specific_insights: report.sport_specific_insights || {},
            grit_leadership_action_plan: report.grit_leadership_action_plan || {},
            conclusion: report.conclusion || {},

        };

        // Overall Summary
        if (formFieldData.overall_summary !== undefined) {
          editableReport.overall_summary = {
            summary: formFieldData.overall_summary || "",
          };
        }

        // Highlights and Strengths - array of {title, description}
        if (Array.isArray(formFieldData.highlights) && Array.isArray(report.highlights_and_strengths)) {
          editableReport.highlights_and_strengths = report.highlights_and_strengths.map(
            (item: any, idx: number) => ({
              title: item.title || "",
              description: formFieldData.highlights[idx] || item.description || "",
            })
          );
        }


          if (Array.isArray(formFieldData.parentFeedback) && Array.isArray(report.parent_feedback_summary)) {
          editableReport.parent_feedback_summary = report.parent_feedback_summary.map(
            (item: any, idx: number) => ({
              title: item.title || "",
              description: formFieldData.parentFeedback[idx] ||  item.description || "",
            })
          );
        }

        // Continuing Development - array of {title, description, explanation}
        if (Array.isArray(formFieldData.continuingDev) && Array.isArray(report.continuing_development)) {
          editableReport.continuing_development = report.continuing_development.map(
            (item: any, idx: number) => ({
              title: item.title || "",
              description: item.description || "",
              explanation: formFieldData.continuingDev[idx] || item.explanation || "",
            })
          );
        }

        // Coach Suggestions for AD Improvement
        if (formFieldData.coachSuggestionsAD !== undefined) {
          if (!editableReport.coach_suggestions_for_ad) {
            editableReport.coach_suggestions_for_ad = formFieldData.coachSuggestionsAD 
          }
        }

        // Resources for Growth - array of {resource_name, description}
        if (Array.isArray(formFieldData.resources) && Array.isArray(report.resources_for_growth)) {
          editableReport.resources_for_growth = report.resources_for_growth.map(
            (item: any, idx: number) => ({
              resource_name: item.resource_name || "",
              description: formFieldData.resources[idx] || item.description || "",
            })
          );
        }

        // Grit Leadership Action Plan - three separate fields
        // const gritPlanFromForm: any = {};
        // if (formFieldData.grit_mid_season_actions !== undefined) {
        //   gritPlanFromForm.mid_season_actions = formFieldData.grit_mid_season_actions || "";
        // }
        // if (formFieldData.grit_post_season_actions !== undefined) {
        //   gritPlanFromForm.post_season_actions = formFieldData.grit_post_season_actions || "";
        // }
        // if (formFieldData.grit_season_end_reviews !== undefined) {
        //   gritPlanFromForm.season_end_reviews = formFieldData.grit_season_end_reviews || "";
        // }
        // // Merge with existing report value (keep other keys intact)
        // editableReport.grit_leadership_action_plan = {
        //   ...(report.grit_leadership_action_plan || {}),
        //   ...gritPlanFromForm,
        // };

       

        console.log("Editable Report Payload:", editableReport);
        return editableReport;
      }
      // Initialize form data from report
      private initializeFormData = () => {
        const { editableReportData } = this.state;
        console.log("Initializing form data from editableReportData:", editableReportData);
        if (!editableReportData || editableReportData.length === 0) {
          return;
        }

        const formData: Record<string, any> = {};

        editableReportData.forEach((report: any, reportIdx: number) => {
          const reportKey = `report_${reportIdx}`;
          
          formData[reportKey] = {
            overall_summary: report.overall_summary?.summary ?? "",
            parentFeedback_appreciate: report.parent_feedback_summary?.parents_appreciate ?? "",
            parentFeedback_suggestions: report.parent_feedback_summary?.suggestions_for_growth ?? "",
            coachSuggestions_0: report.coach_suggestions_for_ad?.[0]?.summary ?? "",
            coachSuggestions_1: report.coach_suggestions_for_ad?.[1]?.summary ?? "",
            team_connectedness_intro: Array.isArray(report.team_connectedness?.intro) 
              ? report.team_connectedness.intro.join(" ") 
              : report.team_connectedness?.intro ?? "",
            coachSuggestionsAD: report.coach_suggestions_for_ad,
            chatgptChanges: report.chatgptChangeResposne || {},
            highlights: (report.highlights_and_strengths || []).map((h: any) => {
              const description = h.description || "";
              const quotes = Array.isArray(h.quotes) && h.quotes.length > 0
                ? `\n${h.quotes.map((q: any) => `${q}`).join("\n")}`
                : "";
              return `${description}${quotes}`.trim();
            }),
            parentFeedback: (report.parent_feedback || []).map((d: any) => d.description || ""),
            continuingDev: (report.continuing_development || []).map((d: any) => {
              const explanation = d.explanation || "";
              const quotes = Array.isArray(d.quotes) && d.quotes.length > 0
                ? `\n${d.quotes.map((q: any) => `${q}`).join("\n")}`
                : "";
              return `${explanation}${quotes}`.trim();
            }),
            resources: (report.resources_for_growth || []).map((r: any) => r.description || ""),
            // Grit Leadership Action Plan separate fields
            grit_mid_season_actions: typeof report.grit_leadership_action_plan?.mid_season_actions === 'string'
              ? report.grit_leadership_action_plan.mid_season_actions
              : (report.grit_leadership_action_plan?.mid_season_actions ?? ""),
            grit_post_season_actions: typeof report.grit_leadership_action_plan?.post_season_actions === 'string'
              ? report.grit_leadership_action_plan.post_season_actions
              : (report.grit_leadership_action_plan?.post_season_actions ?? ""),
            grit_season_end_reviews: typeof report.grit_leadership_action_plan?.season_end_reviews === 'string'
              ? report.grit_leadership_action_plan.season_end_reviews
              : (report.grit_leadership_action_plan?.season_end_reviews ?? ""),
          };
        });

        this.setState({ formData });
      }
      private renderEmailModal() {
        const { emailModalOpen, emailValue, emailSending, emailError, emailSuccess } = this.state as any;
        return (
          <Dialog open={!!emailModalOpen} onClose={this.handleCloseEmailModal}>
            <DialogTitle>Send Report on Email</DialogTitle>
            <DialogContent>
              <TextField
                label="Recipient Email"
                type="email"
                value={emailValue || ""}
                onChange={this.handleEmailChange}
                fullWidth={true}
                autoFocus={true}
                disabled={emailSending}
                margin="dense"
              />
              {emailError && <div style={{ color: "red", marginTop: 8 }}>{emailError}</div>}
              {emailSuccess && <div style={{ color: "green", marginTop: 8 }}>{emailSuccess}</div>}
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleCloseEmailModal} color="secondary" disabled={emailSending}>
                Cancel
              </Button>
              <Button onClick={this.handleSendEmail} color="primary" disabled={emailSending}>
                {emailSending ? "Sending..." : "Send"}
              </Button>
            </DialogActions>
          </Dialog>
        );
      }

      private renderEditableReportData() {
        const { editableReportData, confirmGenerateReportOpen } = this.state as any;
        const isReadOnly = true; // Force read-only mode for report view
        const { hasOpenSurveysInSeason, seasonReportDateRange } = this.props;
        const openSurveyTooltipText = `You have open surveys within this season's reporting period${
          seasonReportDateRange ? ` (${seasonReportDateRange})` : ""
        }. Please close all surveys before generating the seasonal report.`;
        console.log("renderEditableReportData - editableReportData:", editableReportData);
        console.log("editableReportData length:", editableReportData?.length);

        // Open confirmation popup
        const handleOpenConfirmPopup = () => {
          this.setState({ confirmGenerateReportOpen: true });
        };

        // Close popup without action
        const handleCloseConfirmPopup = () => {
          this.setState({ confirmGenerateReportOpen: false });
        };

        // Confirm and run GenerateReport
        const handleConfirmGenerateReport = () => {
          this.setState({ confirmGenerateReportOpen: false }, () => {
            this.GenerateReport();
          });
        };
        // Report history school view is print-only; normal dashboard generation stays unchanged.
        const generateReportButton = this.props.readOnly || this.props.hideGenerateReportButton ? null :
         (
          <>
            <Tooltip
              title={hasOpenSurveysInSeason ? openSurveyTooltipText : ""}
              placement="top"
              arrow={true}
              classes={{ tooltip: this.props.classes.openSurveyTooltip }}
            >
              <span
                style={{
                  display: "block",
                  margin: "24px auto",
                  width: "fit-content"
                }}
              >
                <Button
                  type="button"
                  variant="contained"
                  color="primary"
                  disabled={hasOpenSurveysInSeason}
                  style={{
                    display: "block"
                  }}
                  onClick={handleOpenConfirmPopup} // Confirmation first
                >
                  Generate Report
                </Button>
              </span>
            </Tooltip>

            {/* Confirmation Popup */}
            <Dialog
              open={confirmGenerateReportOpen}
              onClose={handleCloseConfirmPopup}
            >
              <DialogTitle>Confirm Report Generation</DialogTitle>
              <DialogContent>
                Please make sure all surveys for this season have been completed before generating the seasonal report. You can only generate this summary report once.
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCloseConfirmPopup} color="secondary">
                  Back
                </Button>
                <Button
                  onClick={handleConfirmGenerateReport}
                  color="primary"
                  variant="contained"
                >
                  Yes, Generate
                </Button>
              </DialogActions>
            </Dialog>
          </>
        );



        if (!editableReportData || !Array.isArray(editableReportData) || editableReportData.length === 0) {
          return (
            <div style={{ textAlign: "center", color: "#888", margin: "40px 0", fontSize: 20 }}>
              {generateReportButton}
              {this.state.showLoader ? (
                <div style={{ marginTop: 24 }}>
                  {/* <CircularProgress /> */}
                </div>
              ) : (
                <div style={{ marginTop: 24, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}> <ArrowUpwardIcon />  Click on Generate Report to create your report.  {/* No Report found */} </div>

              )}
            </div>
          );
        }
        return (
          <div>
            {this.props.schoolData.ismidseason === false && (
              <h1 style={{ textAlign: "center", marginBottom: 32 }}>
                {/* Reports */}
              </h1>
            )}
            {generateReportButton}


            {editableReportData?.slice(0, 1).map((report: any, reportIdx: number) => {

              const auditDetails = report.audit_details || {};
              const prevSummary = auditDetails.previous_year_summary || {};

              const studentChange = getPercentChange(
                auditDetails.total_students_surveyed,
                prevSummary.total_students_surveyed
              );
              const parentChange = getPercentChange(
                auditDetails.total_parents_surveyed,
                prevSummary.total_parents_surveyed
              );
              const coachChange = getPercentChange(
                auditDetails.total_coaches_surveyed,
                prevSummary.total_coaches_surveyed
              );

              const seasonLabel =
                (auditDetails.season || report.sessionType || "").toString().toUpperCase();

              const keyStrengths: string[] = Array.isArray(report.key_strengths)
                ? report.key_strengths
                : [];
              const improvementOpps: string[] = Array.isArray(report.improvement_opportunities)
                ? report.improvement_opportunities
                : [];

              const highlights: any[] = Array.isArray(report.highlights_and_strengths)
                ? report.highlights_and_strengths
                : [];

             let parentFeedback = report.parent_feedback_summary || [];
             
             // Mark items with title "Supporting Comments" as read-only
             if (Array.isArray(parentFeedback) && parentFeedback.length > 0) {
               parentFeedback = parentFeedback.map((item: any) => ({
                 ...item,
                 isReadOnly: item.title === "Supporting Comments"
               }));
             }

              const continuingDev: any[] = Array.isArray(report.continuing_development)
                ? report.continuing_development
                : [];

              // const coachSuggestions: any[] = Array.isArray(report.coach_suggestions_for_ad)
              //   ? report.coach_suggestions_for_ad
              //   : [];

              const resourcesForGrowth: any[] = Array.isArray(report.resources_for_growth)
                ? report.resources_for_growth
                : [];

              const gritPlan = report.grit_leadership_action_plan || {};

              const teamConnectedness = report.team_connectedness || {};

              const schoolName = this.props?.schoolData?.name || this.props.schoolData?.schoolName;
              const schoolLogo = this.props?.schoolData?.logo1;
              const conclusionInfoText = report.conclusion?.message || "";

              const strengthIcons = ["far fa-smile", "fas fa-heart", "fas fa-comments"];

              return (
                <form
                key={report.id}
                onSubmit={async (e) => {
                  e.preventDefault();
                  if (isReadOnly) { return; }
                  try {
                    // Build editable report payload dynamically from state
                    const editableReport = this.buildEditableReportPayload(report, reportIdx);

                    console.log("Editable Report being sent:", editableReport);

                    const UpdateReportData = await this.buildPost<any, any>(
                      this, "/reports/reportUpdate"
                    )([editableReport]);
                   console.log("Report updated successfully:", UpdateReportData);
                    alert("Report updated successfully!");
                    this.props.refreshReports();

                  } catch (error) {
                    console.error("Error in ReportData", error);
                  }
                }}
                  style={{

                    background: "#f9f9f9",

                  }}
                >
                <div style={{ display: "flex", flexDirection: "column", gap: "15px", justifyContent: "space-between" }}>

                  {/* <div className="title-container 1111111111111" style={{ display: "flex", justifyContent: "space-between" }}>
                    <h3>{schoolName}</h3>
                    {schoolLogo && (
                      <img src={schoolLogo} alt="School Logo" style={{ width: 50, height: 50 }} />
                    )}
                  </div> */}

                  <div className="date-print-button " style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ color: "#000", fontWeight: "bold", fontSize: "12px", display: "flex", justifyContent: "start", gap: "25px" }}>
                      <div>
                        {auditDetails.report_date
                          ? format(new Date(auditDetails.report_date), "MMMM D, YYYY")
                          : format(report.date, "MMMM D, YYYY")}
                      </div>
                      <div> {seasonLabel}</div>
                      {/* <div style={{ fontWeight: 500, color: "#555" }}> {this.props?.coach.name} </div> 
                      <div style={{ fontWeight: 500, color: "#555" }}>{this.props?.sport.name} </div>  */}

                    </div>
                    <div>


                      <Button
                        type="button"
                        variant="contained"
                        color="secondary"
                        style={{ marginRight: "10px" }}
                        onClick={() => this.handlePrint(report)}
                      >
                        Print
                      </Button>
                      {/* <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        style={{ marginRight: 0, float: "right" }}
                      >
                        Update
                      </Button> */}




                    </div>
                  </div>
                </div>
                <div style={{ borderTop: "1px solid #eee", margin: "10px 0px" }} />
              
                
              <div id="reprotNewContainer">
                <div className="top-section">
                  <div className="report-header">
                    <div className="header-left">
                      <p className="subtitle">Athletic Program Snapshot - {seasonLabel}</p> 
                      <h1 className="title">{schoolName}</h1>
                    </div>

                    <div className="header-right">
                      {schoolLogo && (
                        <img src={schoolLogo} alt="School Logo" style={{ width: "50px", height: "50px" }} />
                      )}
                    </div>
                  </div>
                  <div className="three-points-container">
                    <div className="surveyed-score">
                      <div className="stat">
                        <strong>{auditDetails.total_students_surveyed ?? "-"}</strong>
                        <span>students surveyed</span>
                        <p>
                          <small className={getPercentClass(studentChange)}>
                            {formatPercent(studentChange)}
                          </small>{" "}
                          from {prevSummary.year ?? ""}
                        </p>
                      </div>

                      <div className="stat">
                        <strong>{auditDetails.total_parents_surveyed ?? "-"}</strong>
                        <span>parents surveyed </span>
                        <p>
                          <small className={getPercentClass(parentChange)}>
                            {formatPercent(parentChange)}
                          </small>{" "}
                          from {prevSummary.year ?? ""}{" "}
                        </p>
                      </div>

                      <div className="stat">
                        <strong>{auditDetails.total_coaches_surveyed ?? "-"}</strong>
                        <span>coach responses</span>
                        <p>
                          <small className={getPercentClass(coachChange)}>
                            {formatPercent(coachChange)}
                          </small>{" "}
                          from {prevSummary.year ?? ""}{" "}
                        </p>
                      </div>
                    </div>

                    <div className="report-card">
                      <div className="report-date">
                        <span className="label">report date</span>
                        <strong>
                              {auditDetails?.report_date
                                ? format(new Date(auditDetails.report_date), "MMMM D, YYYY")
                                : ""}
                        </strong>
                      </div>
                      <div className="season">{seasonLabel}</div>
                    </div>
                  </div>


                  <div className="three-points-container">
                    <div className="three-points">
                      <h6>Key Strengths</h6>
                      <div className="pill-row">
                        {keyStrengths.map((item) => (
                          <span key={item} className="pill">
                            {String(item).toUpperCase()}
                          </span>
                        ))}
                      </div>
                    </div>
                    <div className="three-points">
                      <h6>Improvement Opportunities </h6>
                      <div className="pill-row">
                        {improvementOpps.map((item) => (
                          <span key={item} className="pill">
                            {String(item).toUpperCase()}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="main-summary">
                  <div className="card pad">
                    <h5>Highlights and Strengths</h5>
                    <div className="list">
                      {highlights.map((item, idx) => {
                        const description = item.description ?? "";
                        const quotes = Array.isArray(item.quotes) && item.quotes.length > 0
                          ? `\n${item.quotes.map((q: any) => `${q}`).join("\n")}`
                          : "";
                        const combinedText = `${description}${quotes}`.trim();
                        return (
                          <div key={idx} className="item">
                            <div className="icon">
                              <i className={strengthIcons[idx] || "far fa-smile"} />
                            </div>
                            <div>
                              <h4>{item.title}:</h4>
                              <p
                                style={{
                                  width: "100%",
                                  margin: 0,
                                  whiteSpace: "pre-wrap",
                                  wordBreak: "break-word",
                                }}
                              >
                                {this.state.formData?.[`report_${reportIdx}`]?.highlights?.[idx] ?? combinedText}
                              </p>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  <div className="card pad summary">
                    <h5>Summary</h5>
                    <p
                      style={{
                        width: "100%",
                        background: "transparent",
                        border: "none",
                        boxSizing: "border-box",
                        fontFamily: "'Lato', sans-serif",
                        whiteSpace: "pre-wrap",
                        minHeight: "60px",
                        margin: 0
                      }}
                    >
                      {this.state.formData?.[`report_${reportIdx}`]?.overall_summary ?? ""}
                    </p>
                  </div>
                </div>

                <div className="summry-bottom">
                  <div className="card pad">
                    <h5>Parent Feedback Summary</h5>
                   
                     {parentFeedback.map((item:any, idx:any) => {
                       // Check if this is the read-only item (Supporting Comments - 3rd item)
                       
                       const isItemReadOnly = item.isReadOnly === true;
                       const isSpecialHeading =
                         item.title === "Parents Appreciate" ||
                         item.title === "Suggestions for Growth";
                       const headingStyle: React.CSSProperties | undefined = isSpecialHeading
                         ? ({
                             fontSize: "16px",
                             fontWeight: 600,
                             textAlign: "center",
                             marginBottom: "5px",
                           } as React.CSSProperties)
                         : undefined;
                       
                       if (isItemReadOnly) {
                         const description = item.description ?? "";
                         const quote = item.quote ? `\n"${item.quote}"` : "";
                         const combinedText = `${description}${quote}`.trim().replace(/\n\s*\n/g, "\n");
                         
                         return (
                           <div key={idx} className="whiteBox pad" style={{ paddingBottom: 0 }}>
                             <h4 style={headingStyle}>{item.title}</h4>
                             <p style={{ 
                               whiteSpace: "pre-wrap", 
                               wordWrap: "break-word",
                               marginBottom: 0,
                               paddingBottom: 0
                             }}>
                               {combinedText}
                             </p>
                           </div>
                         );
                       }
                       
                       const description = this.state.formData?.[`report_${reportIdx}`]?.parentFeedback?.[idx] ?? item.description ?? "";
                       const quote = item.quote ? `\n"${item.quote}"` : "";
                       const combinedText = `${description}${quote}`.trim();
                       
                       return (
                        <div key={idx} className="whiteBox pad" style={{ paddingBottom: 0 }}>
                          <h4 style={headingStyle}>{item.title}</h4>
                          <p
                            style={{
                              width: "100%",
                              border: "none",
                              boxSizing: "border-box",
                              whiteSpace: "pre-wrap",
                              minHeight: 0,
                              margin: 0,
                              marginBottom: 0,
                              paddingBottom: 0,
                              wordBreak: "break-word"
                            }}
                          >
                            {combinedText}
                         </p>
                        </div>
                      );
                     
                     })}
                      
                  

                  </div>

                  <div className="card pad">
                   
                    <div className="connectedness">
                    <div className="tc-header">
                      <h5>Team Connectedness</h5>
                      <span
                        ref={(el) => {
                          if (el) {
                            el.style.setProperty("color", "rgba(0, 0, 0, 1)", "important");
                            el.style.setProperty("opacity", "1", "important");
                          }
                        }}
                        style={{ color: "rgba(0, 0, 0, 1)", opacity: 1 }}
                      >
                        Scored out of 10.0
                      </span>
                    </div>
                    <div className="scores">
                      {(teamConnectedness?.markers || []).map((item:any, idx:any) => {
                       const scoreValue = (item.score != null && item.score !== '' && !isNaN(Number(item.score))) ? Number(item.score) : 0;
                       const roundedScore = Math.round(scoreValue * 10) / 10;
                       const deg = Math.min(360, Math.max(0, (scoreValue / 10) * 360));
                       const staticLabel = DEFAULT_TEAM_CONNECTEDNESS_SCORES[idx]?.label || item.label || '';
                        return (
                        <div key={idx} className="score">
                          <div
                            className="ring"
                            style={{
                              background: `conic-gradient(from 90deg, #0b3a6f 0deg ${deg}deg, #e6edf4 ${deg}deg 360deg)`,
                            }}
                          >
                            <span>{roundedScore.toFixed(1)}</span> 
                          </div>
                          <p>{staticLabel}</p>
                        </div>
                      );})}
                    </div>
                  </div>
                    <div className="overallOuter">
                      <div className="overallInfo">
                       <p>Connectedness and belonging are key drivers of individual and team performance. Research shows that when athletes feel connected—to teammates and coaches—they develop a stronger sense of belonging and invest more in the team, school, and community. Highly connected programs consistently perform at higher levels on and off the field.</p>
                    
                      </div>
                      <div className="overall">
                        <span>
                          Averaged from {Array.isArray(teamConnectedness?.markers)
                            ? teamConnectedness.markers.filter((item: any) => {
                                const responses = Number(item.responses);
                                return !isNaN(responses) && responses > 0;
                              }).length
                            : 0} questions with data
                        </span>
                        {/* <span>
                          <small>{teamConnectedness.overall_change ?? ""}</small>{" "}
                          {teamConnectedness.overall_change && "from previous season"}
                        </span> */}
                        <strong>
                          {teamConnectedness.overall_score != null && !isNaN(Number(teamConnectedness.overall_score))
                            ? (Math.round(Number(teamConnectedness.overall_score) * 10) / 10).toFixed(1)
                            : "-"}
                        </strong>
                        <p>Overall Team Connectedness Score </p>
                      </div>
                    </div>
                  </div>
                </div>


                 <div className="continue-development">
                  <div className="card pad">
                    <h5>Continuing Development</h5>
                    <div className="list">
                      {continuingDev.map((item, idx) => {
                        const explanation = item.explanation ?? "";
                        const quotes = Array.isArray(item.quotes) && item.quotes.length > 0
                          ? `\n${item.quotes.map((q: any) => `${q}`).join("\n")}`
                          : "";
                          
                        const combinedText = `${explanation}${quotes}`.trim();
                        return (
                        <div key={idx} className="item">
                          <div className="icon">
                            <i
                              className={
                                idx === 0
                                  ? "fas fa-bullhorn"
                                  : idx === 1
                                  ? "far fa-lightbulb"
                                  : "far fa-user"
                              }
                            />
                          </div>
                          <div>
                            <h4>
                              {item.title}: {item.description}
                            </h4>
                            <p
                              style={{
                                width: "100%",
                                border: "none",
                                boxSizing: "border-box",
                                whiteSpace: "pre-wrap",
                                minHeight: "60px",
                                margin: 0,
                                wordBreak: "break-word"
                              }}
                            >
                              {this.state.formData?.[`report_${reportIdx}`]?.continuingDev?.[idx] ?? combinedText}
                            </p>
                          </div>
                        </div>
                      )})}
                    </div>

                    <div className="whiteBox pad coachsuggestion">
                       <h6>Coach Suggestions for AD Improvement</h6>
                      {/* {(() => {
                        const coachSuggestions = Array.isArray(report.coach_suggestions_for_ad) ? report.coach_suggestions_for_ad : [];
                        const combinedText = coachSuggestions.map((item: any) => {
                         // const theme = item.theme ? `${item.theme}: ` : "";
                          const summary = item.summary ?? "";
                          const quotes = Array.isArray(item.quotes) && item.quotes.length > 0
                            ? "\n\nQuotes:\n" + item.quotes.map((q: any) => `"${q}"`).join("\n")
                            : "";
                          return `${summary}${quotes}`.trim();
                        }).join("\n\n");
                        return ( */}
                          <p
                            style={{
                              width: "100%",
                              border: "none",
                              boxSizing: "border-box",
                              whiteSpace: "pre-wrap",
                              minHeight: "60px",
                              margin: 0,
                              wordBreak: "break-word"
                            }}
                          >
                            {(this.state.formData?.[`report_${reportIdx}`]?.coachSuggestionsAD ?? report.coach_suggestions_for_ad)?.replace(/\n\s*\n/g, "\n")}
                          </p>
                        {/* );
                      // })()} */}
                    </div>


                  </div>
                  <div className="card pad">
                  <div className="resources-for-growth-heading-wrap" style={{ marginBottom: 0 }}>
                  <h5 style={{ margin: 0, padding: 0 }}>Resources for Growth</h5>
                  </div>
                    <div className="resource-container" style={{ marginTop: 0 }}>
                      {resourcesForGrowth.map((item, idx) => {
                          let paragraphText = this.state.formData?.[`report_${reportIdx}`]?.resources?.[idx] ?? item.description ?? "";
                          if (typeof paragraphText === "string") {
                            const otherTitles = resourcesForGrowth
                              .map((r: any) => (r.resource_name || "").trim())
                              .filter((t: string) => t && t !== (item.resource_name || "").trim());
                            const otherTitlesSet = new Set(otherTitles);
                            const normalize = (s: string) => s.replace(/\*+/g, "").trim();
                            let lines = paragraphText.split(/\r?\n/);
                            lines = lines.filter((line: string) => !otherTitlesSet.has(normalize(line)));
                            paragraphText = lines
                              .map((line: string) => {
                                let cleaned = line;
                                otherTitles.forEach((title: string) => {
                                  cleaned = cleaned.replace(new RegExp(`\\*\\*${title.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\*\\*`, "g"), "");
                                });
                                return cleaned.trim();
                              })
                              .join("\n")
                              .trim();
                          }
                          const isWinTheDay = (item.resource_name || "").trim().toLowerCase() === "win the day";
                          const isChampions101 = (item.resource_name || "").trim().toLowerCase() === "champions 101";
                          return (
                        <div key={idx} className="whiteBox pad resources-growth-box">
                         <div className="printclass"> 
                          {isWinTheDay && (
                            <div className="resources-growth-logo" style={{ display: "flex", justifyContent: "center", width: "100%", marginBottom: "0", marginLeft: 0, paddingLeft: 0 }}>
                              <img
                                src={winTheDayImg}
                                alt="Win the Day"
                                style={{ maxWidth: "80%", height: "auto", display: "block", margin: "0 auto" }}
                              />
                            </div>
                          )}
                          {isChampions101 && (
                            <div className="resources-growth-logo" style={{ display: "flex", justifyContent: "center", width: "100%", marginBottom: "0", marginLeft: 0, paddingLeft: 0 }}>
                              <img
                                src={champions101Img}
                                alt="Champions 101"
                                style={{ maxWidth: "80%", height: "auto", display: "block", margin: "0 auto" }}
                              />
                            </div>
                          )}
                          <p className="title-para" style={{ fontWeight: "bold",marginBottom: "10px",fontSize: "18px", textAlign: "center", fontStyle: "normal", ...(isWinTheDay || isChampions101 ? { display: "none" } : {})}}>{item.resource_name}</p>
                          {(() => {
                            const rawText = typeof paragraphText === "string" ? paragraphText : "";
                            const urlMatches = rawText.match(/(https?:\/\/[^\s]+)/g) || [];
                            const cleanedText = rawText.replace(/(https?:\/\/[^\s]+)/g, "").trim();
                            const linkHtml = urlMatches
                              .map(
                                (url) =>
                                  `<div><a href="${url}" target="_blank" rel="noopener noreferrer">Click here to learn more</a></div>`
                              )
                              .join("");

                            return (
                              <p
                                style={{
                                  width: "100%",
                                  border: "none",
                                  boxSizing: "border-box",
                                  whiteSpace: "pre-wrap",
                                  minHeight: "60px",
                                  margin: 0,
                                  wordBreak: "break-word"
                                }}
                                dangerouslySetInnerHTML={{
                                  __html: `${cleanedText}${linkHtml ? `<br/>${linkHtml}` : ""}`
                                }}
                              />
                            );
                          })()}
                        </div>
                       </div>
                          );
                      })}
                    </div>
                  
                  </div>
                </div>

                <div className="conclusion">
            
                 <div className="card pad">

                  <h5>Conclusions </h5>

                  <div className="whiteBox pad">
                   
                    <div className="action-plan-wrapper">
                       <h5> Grit Leadership Action Plan </h5>
                        <div className="timeline">
                         {gritPlan.mid_season_actions !== undefined && (
                              <div className="step">
                                <div className="smallcard">
                                
                                <div style={{fontStyle: "italic", width: "100%", border: "none", boxSizing: "border-box", background: "transparent", whiteSpace: "pre-wrap", wordWrap: "break-word", fontSize: 14, lineHeight: 1.6 }}>
                                  {this.state.formData?.[`report_${reportIdx}`]?.grit_mid_season_actions ?? (typeof gritPlan.mid_season_actions === 'string' ? gritPlan.mid_season_actions : '')}
                                </div>
                                </div>
                                <span className="dot">&nbsp;</span>
                                <span className="label">mid-season</span>
                              </div>
                            )}

                          {gritPlan.post_season_actions !== undefined && (
                              <div className="step">
                                <div className="smallcard">
                          
                                <div style={{fontStyle: "italic",textAlign: "left", width: "100%", border: "none", boxSizing: "border-box", background: "transparent", whiteSpace: "pre-wrap", wordWrap: "break-word", fontSize: 14, lineHeight: 1.6 }}>
                                  {this.state.formData?.[`report_${reportIdx}`]?.grit_post_season_actions ?? (typeof gritPlan.post_season_actions === 'string' ? gritPlan.post_season_actions : '')}
                                </div>
                                </div>
                                <span className="dot">&nbsp;</span>
                                <span className="label">post-season</span>
                              </div>
                            )}

                          {gritPlan.season_end_reviews !== undefined && (
                              <div className="step">
                                <div className="smallcard">
                                
                                <div style={{fontStyle: "italic",textAlign: "left", width: "100%", border: "none", boxSizing: "border-box", background: "transparent", whiteSpace: "pre-wrap", wordWrap: "break-word", fontSize: 14, lineHeight: 1.6 }}>
                                  {this.state.formData?.[`report_${reportIdx}`]?.grit_season_end_reviews ?? (typeof gritPlan.season_end_reviews === 'string' ? gritPlan.season_end_reviews : '')}
                                </div>
                                </div>
                                <span className="dot">&nbsp;</span>
                                <span className="label">season-end</span>
                              </div>
                            )}
                        </div>
                      </div>

                  </div>

                  <div className="conclusion-infotext">
                   <h5> A Note From Our Founder </h5>
                   <p>
                      {conclusionInfoText}
                     
                   </p>
                   <h5> Kevin Broene</h5>
                 </div>               
                </div>
              </div>
            </div>
                {Object.keys(report.chatgptChangeResposne).map((key) => {

                  const original = report.chatgptChangeResposne[key] || '';
                  const value = String(original);

                  let contentBody = null;

                  // Special rendering for "Team Connectedness:"
                  if (key.trim().toLowerCase().includes("team connectedness")) {
                    contentBody = (
                      <div className="team-connectedness-section" style={{ marginBottom: 20 }}>
                        <pre style={{ scrollbarColor: "none", all: "unset", margin: "0", whiteSpace: "normal" }}>
                          <span className="textarea-fontFamily"
                            dangerouslySetInnerHTML={{
                              __html: value.replace(/\*\*(.*?)\*\*/g, "<b>$1</b>").replace(/\*(.*?)\*/g, "<b>$1</b>")
                            }}
                          />
                        </pre>
                      </div>
                    );
                  } else {

                    contentBody = (

                      <div
                        className="editable-div textarea-fontFamily"
                        style={{
                          width: "100%",
                          minHeight: 80,
                          fontSize: 13,
                          padding: 10,
                          borderRadius: 4,
                          border: "1px solid #bbb",
                          background: "#f1f1f1",
                          lineHeight: "17px",
                          whiteSpace: "pre-wrap"
                        }}
                        dangerouslySetInnerHTML={{
                          __html: cleanAndFormatHtml_New(typeof value === "string" ? value : "")
                        }}
                      />
                    )
                  }

                  return (
                    <div key={key} style={{ marginBottom: 14 }}>
                      <label
                        className="title-fontFamily"
                        style={{
                          fontWeight: "400",
                          fontSize: 17,
                          display: "block",
                          marginTop: 15,
                          marginBottom: 6,
                          color: "white",
                          padding: "0px 8px",
                          borderTop: "2px solid #000",
                          borderBottom: "2px solid #000",
                          backgroundColor: this.props.schoolData?.primaryColor
                        }}
                      >
                        {key}
                      </label>

                      {contentBody}

                    </div>

                  );
                })}
                <div style={{ paddingBottom: "15px", marginBottom: "15px" }}>
                  {/* <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    style={{ marginRight: "0px", float: "right", marginBottom: "15px" }}
                  >
                    Update
                  </Button> */}
                  <Button
                    type="button"
                    variant="contained"
                    color="secondary"
                    style={{ marginRight: "10px", float: "right", marginBottom: "15px" }}
                    onClick={() => this.handlePrint(report)}
                  >
                    Print
                  </Button>
                </div>
                <style>
                  {`
                      .team-connectedness-section p,
                      .team-connectedness-section table td,
                      .team-connectedness-section table th,
                      .textarea-fontFamily, .textarea-fontFamily * {
                          font-family: Open Sans, sans-serif !important;	
                       
                        }
                        .team-connectedness-section table td,
                        .team-connectedness-section table th {
                          padding: 5px 10px !important;
                        }
                      .team-connectedness-section p {
                        font-weight:bold;
                      } 
                        .team-connectedness-section table thead th {
                          white-space:nowrap;
                        }
                        .team-connectedness-section b,          
                      .team-connectedness-section p,
                      .team-connectedness-section table td,
                      .team-connectedness-section table th {
                        font-size:13px;
                        color:#000;
                      }
                      .title-heading {
                        font-family: "Russo One", Arial, sans-serif !important;
                        font-size: 24px;
                        margin-bottom: 3px;
                      }
                        .title-fontFamily {
                        font-family: Russo One, Arial, sans-serif !important;
                        }
                        
                       @media print {
                            .footer-logo {
                                  position: fixed !important;
                                  bottom: 10px !important;
                                  width: 100%;
                                  text-align: center;
                                  left: 0%;
                                  transform: translateX(50%, 50%);
                                                  
                              }
                          
                              .footer-logo img {
                                  height: 27px !important;
                                  width: 27px!important;
                                  bottom: 0px !important;
                                      position: absolute !important;
                                  text-align: center;
                                  transform: translateX(50%, -50%);
                                  left: 48% !important;
                              }   
                                @page {
                                margin-bottom: 20mm; /* Prevent clipping at bottom */
                              }  
                               .title-fontFamily {
                                  font-family: Russo One, Arial, sans-serif !important;
                                  }                  
                          
                          }
              
                `}
                </style>
                <div id={`printable-report-${report.id}`} style={{ display: "none", position: "relative" }}>
                  <div style={{ border: "none", paddingBottom: 80 }}>

                    <div style={{ marginBottom: 20 }}>
                      <h2 className="title-fontFamily" style={{ textAlign: "left" }}>Annual Report</h2>
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <h3 className="title-fontFamily"> {this.props?.schoolData?.name} </h3>
                        <img src={this.props?.schoolData?.logo1} alt="School Logo" style={{ position: "relative", top: "-5px", width: 70, height: 70 }} />

                      </div>
                      {/* <strong style={{ fontWeight: 500, color: "#555" }}> Coach: {this.props?.coach.name} </strong> <br />
                      <strong style={{ fontWeight: 500, color: "#555" }}> Sport: {this.props?.sport.name} </strong> <br /> */}
                      <div style={{ display: "flex", justifyContent: "start", gap: "25px" }}>
                        <div className="title-fontFamily"> {format(report.date, "MMMM D, YYYY")}</div>
                        <div className="title-fontFamily"> {report.sessionType} </div>
                      </div>
                    </div>

                    {Object.keys(report.chatgptChangeResposne).map((key, index) => {
                      // const value = report.chatgptChangeResposne[key];
                      const original = report.chatgptChangeResposne[key] || '';
                      const value = String(original).includes('\n')
                        ? original
                        : String(original)


                      return (
                        <React.Fragment key={`${key}-${index}`}>
                          <div className="report-section" style={{ marginBottom: 25 }}>

                            {/* {titleContent} */}

                            <div className="titleColored" style={{
                              padding: "6px 10px", borderTop: " 2px solid #000", borderBottom: " 2px solid #000",
                              background: this.props.schoolData?.primaryColor, color: "#fff", fontWeight: "bold", fontSize: 16, marginBottom: 4
                            }}>
                              {key}:

                            </div>
                            <div style={{
                              background: "#f4f7fa",
                              borderRadius: 4,
                              padding: 12,
                              fontSize: 15,
                              color: "#222",
                              border: "1px solid #e0e0e0",
                              whiteSpace: "normal",

                            }}>

                              <style>
                                {`
                                  @media print {
                                    .textarea-fontFamily {
                                      font-family: 'Open Sans', sans-serif !important;
                                    }
                                  }
                                `}
                              </style>

                              <div id={`printable-report-${report.id}`}>
                                {/* Printable content here */}

                                <pre style={{ scrollbarColor: "none", all: "unset", margin: "0", whiteSpace: "normal" }} >
                                  <span className="textarea-fontFamily"
                                    style={{ fontSize: '13px' }}
                                    dangerouslySetInnerHTML={{
                                      __html: value
                                        .replace(/\*\*(.*?)\*\*/g, "<b>$1</b>")
                                        .replace(/\*(.*?)\*/g, "<b>$1</b>")
                                    }}
                                  />
                                </pre>
                              </div>
                            </div>
                          </div>
                          {/* {(index + 1) % 4 === 0 && (
                              <div
                                className="page-break"
                                style={{ pageBreakAfter: "always", display: "block" }}
                              />
                            )} */}
                        </React.Fragment>
                      );
                    })}



                    {/* Fixed logo for print */}

                    <div
                      className="footer-logo"
                      style={{
                        position: 'fixed',
                        top: "auto",
                        bottom: '20px',
                        width: '100%',
                        textAlign: 'center',
                        zIndex: 10000
                      }}
                    >
                      <img
                        src={gritLogo}
                        alt="Grit Leadership Logo"
                        style={{ height: '30px', position: "absolute", bottom: "0px" }}
                      />
                    </div>

                  </div>
                </div>
              </form>
            ); })}
            {this.renderEmailModal()}
          </div>
        );
      }
    }
  )
);




// WEBPACK FOOTER //
// ./src/pages/director/dashboard/reportGeneratemodal.tsx